document.addEventListener('DOMContentLoaded', () => {
  let _pdfReady = !1;
  function ensurePdfJs() {
    return _pdfReady
      ? Promise.resolve()
      : new Promise((resolve, reject) => {
          const s = document.createElement('script');
          ((s.src = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js'),
            (s.crossOrigin = 'anonymous'),
            (s.referrerPolicy = 'no-referrer'),
            (s.onload = () => {
              (typeof pdfjsLib < 'u' && (pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js'),
                (_pdfReady = !0),
                resolve());
            }),
            (s.onerror = reject),
            document.head.appendChild(s));
        });
  }
  const $ = (s, r = document) => r.querySelector(s),
    $$ = (s, r = document) => [...r.querySelectorAll(s)],
    slug = (t) => (t || '').toLowerCase().replace(/[^a-z0-9]+/g, ''),
    clamp = (n, min, max) => Math.max(min, Math.min(n, max)),
    IS_INTL = typeof location < 'u' && /\/en-intl(\/|$)/.test(location.pathname || ''),
    CURRENCY_SYMBOL = IS_INTL ? 'US$' : '$',
    formatMoney = (n) => CURRENCY_SYMBOL + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (IS_INTL) {
    const freeShipEl = document.querySelector('.ldm-free-ship');
    freeShipEl && (freeShipEl.textContent = '+ Free international shipping');
    const breakdownNote = document.querySelector('#ldm-breakdown .ldm-tooltip-note');
    breakdownNote && (breakdownNote.textContent = '*Free international shipping included. Excludes taxes. No hidden setup fees.');
    const shipLong = document.querySelector('.ldm-social-proof-stat:last-of-type .ldm-sp-long'),
      shipShort = document.querySelector('.ldm-social-proof-stat:last-of-type .ldm-sp-short');
    (shipLong && (shipLong.textContent = 'Free international shipping'), shipShort && (shipShort.textContent = 'Free intl shipping'));
  }
  const NETLIFY_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/create-draft-order',
    EMAIL_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/send-wholesale-email',
    SAVE_DESIGN_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/save-design',
    LOAD_DESIGN_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/load-design',
    SHOPIFY_FILES_CDN = 'https://cdn.shopify.com/s/files/1/0068/5123/1797/files/';
  function detectPixelId() {
    try {
      if (window._fbq && window._fbq.instance && window._fbq.instance.pixelsByID) {
        const ids = Object.keys(window._fbq.instance.pixelsByID);
        if (ids.length) return ids[0];
      }
      if (window.fbq && typeof window.fbq.getState == 'function') {
        const st = window.fbq.getState();
        if (st && st.pixels && st.pixels[0] && st.pixels[0].id) return st.pixels[0].id;
      }
    } catch {}
    return '';
  }
  function _cookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? m[1] : '';
  }
  function _subdomainIndex() {
    const h = (location.hostname || '').toLowerCase();
    if (!h || h === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(h)) return 0;
    const n = h.split('.').length;
    return n <= 1 ? 0 : n - 1;
  }
  try {
    const _m = (location.search || '').match(/[?&]fbclid=([^&#]+)/),
      _fbcl = _m ? _m[1] : '';
    _fbcl && ((localStorage.getItem('_ld_fbc') || '').endsWith('.' + _fbcl) || localStorage.setItem('_ld_fbc', 'fb.' + _subdomainIndex() + '.' + Date.now() + '.' + _fbcl));
  } catch {}
  function getFbp() {
    return _cookie('_fbp') || '';
  }
  function getFbc() {
    const c = _cookie('_fbc');
    if (c) return c;
    try {
      return localStorage.getItem('_ld_fbc') || '';
    } catch {}
    return '';
  }
  function genEventId(prefix) {
    const rand =
      crypto && crypto.randomUUID ? crypto.randomUUID().replace(/-/g, '').slice(0, 16) : Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
    return (prefix || 'ev') + '_' + Date.now() + '_' + rand;
  }
  function fbAdvancedInit(email) {
    if (typeof fbq != 'function' || !email) return;
    const pid = detectPixelId();
    if (pid)
      try {
        fbq('init', pid, { em: email.trim().toLowerCase() });
      } catch {}
  }
  const TIERS = [
      { q: 25, price: 23 },
      { q: 50, price: 16.5 },
      { q: 100, price: 14.5 },
      { q: 250, price: 12.5 },
      { q: 500, price: 10.5 },
      { q: 1e3, price: 9 },
    ],
    EMB_PRICE = 3,
    MAX_FILE = 10 * 1024 * 1024,
    esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]),
    P = JSON.parse($('#ldm-data').textContent || '{}'),
    PRODUCT_NAME =
      'Custom ' +
      (P.title || 'Classic Cap')
        .replace(/^\s*lift down\s+/i, '')
        .replace(/^\s*custom\s+/i, '')
        .trim(),
    rowSizesLabel = (r) => (!r.s && !r.xl ? `R ${r.qty}` : `S ${r.s} / R ${Math.max(0, r.qty - r.s - r.xl)} / XL ${r.xl}`),
    COLOR_IDX = Math.max(
      0,
      (P.options || []).findIndex((o) => (o || '').toLowerCase().includes('color')),
    ),
    VARIANTS = P.variants || [],
    COLORS = [...new Set(VARIANTS.map((v) => (v[`option${COLOR_IDX + 1}`] || '').trim()).filter(Boolean))],
    LOOK = { Front: {}, Back: {}, Left: {}, Right: {}, Side: {} },
    ALL = { Front: [], Back: [], Left: [], Right: [], Side: [] };
  (P.media || []).forEach((m) => {
    const url = m.url || '',
      tokens = url
        .split('/')
        .pop()
        .split('?')[0]
        .replace(/\.[a-z0-9]+$/i, '')
        .toLowerCase()
        .split(/[-_ ]+/),
      tok = ' ' + tokens.join(' ') + ' ';
    let side = null;
    if (
      (/\bfront\b/i.test(tok)
        ? (side = 'Front')
        : /\bback\b/i.test(tok)
          ? (side = 'Back')
          : /\bleft\b/i.test(tok)
            ? (side = 'Left')
            : /\bright\b/i.test(tok)
              ? (side = 'Right')
              : /\bside\b/i.test(tok) && (side = 'Side'),
      !side)
    )
      return;
    const cslug = tokens
      .filter((t) => !['front', 'back', 'left', 'right', 'side'].includes(t))
      .join('')
      .replace(/[^a-z0-9]/g, '');
    (cslug && (LOOK[side][cslug] = url), ALL[side].push({ slug: cslug, url }));
  });
  function imageFor(color, side, width = 800) {
    const sized = (source) => {
        const url = new URL(source, window.location.origin);
        return (url.searchParams.set('width', String(width)), url.href);
      },
      cs = slug(color);
    if (LOOK[side]?.[cs]) return { url: sized(LOOK[side][cs]), flip: !1 };
    if (side === 'Side') {
      const hit = ALL.Side.find((o) => o.slug.includes(cs)) || ALL.Left.find((o) => o.slug.includes(cs)) || ALL.Right.find((o) => o.slug.includes(cs));
      if (hit) return { url: sized(hit.url), flip: !1 };
    }
    const cdnName = color.replace(/\s+/g, '-');
    return { url: sized(SHOPIFY_FILES_CDN + cdnName + '-' + side + '.png'), flip: !1 };
  }
  const SWATCH_MAP = JSON.parse($('#ldm-swatches-data').textContent || '{}');
  function swatchImage(color) {
    if (SWATCH_MAP[color]) return SWATCH_MAP[color];
    const cdnName = color.replace(/\s+/g, '-');
    return SHOPIFY_FILES_CDN + cdnName + '-Front.png?width=200';
  }
  const PLACEMENT_DEFAULTS = { Front: { x: 50, y: 47, w: 100, r: 0 }, Back: { x: 50, y: 54, w: 100, r: 0 }, Side: { x: 57, y: 55, w: 100, r: 0 } },
    DD = (side) => ({
      file: null,
      data: null,
      placement: { ...(PLACEMENT_DEFAULTS[side] || PLACEMENT_DEFAULTS.Front) },
      pdfPage: 0,
      mode: 'file',
      textConfig: { text: '', font: 'DM Sans', color: '#FFFFFF', size: 64, align: 'center', curve: 0 },
    }),
    state = { color: COLORS[0] || '', side: 'Front', qty: 25, mix: null, sizes: { s: 0, xl: 0 }, designs: { Front: DD('Front'), Back: DD('Back'), Side: DD('Side') } };
  let mixPreviewColor = null;
  function displayedColor() {
    return mixOn() && mixPreviewColor ? mixPreviewColor : state.color;
  }
  const stageEl = $('#ldm-stage'),
    stageImg = $('#ldm-stage-img'),
    MIN_LOGO_PCT_CAP = 0.04,
    MIN_LOGO_PX = 14,
    minLogoW = () => Math.max(MIN_LOGO_PX, (stageImg.offsetWidth || stageEl.clientWidth * 0.85) * MIN_LOGO_PCT_CAP),
    logo = $('#ldm-logo'),
    logoImg = $('#ldm-logo-img'),
    stageBtns = $('#ldm-stage-btns'),
    stageBtnUpload = $('#ldm-stage-btn-upload'),
    stageBtnText = $('#ldm-stage-btn-text'),
    inlineTextEl = $('#ldm-inline-text'),
    inlineTextInput = $('#ldm-inline-text-input'),
    inlineTextDone = $('#ldm-inline-text-done'),
    swatchesEl = $('#ldm-swatches'),
    tabsEl = $('#ldm-tabs'),
    uploadEl = $('#ldm-upload'),
    uploadInput = $('#ldm-upload-input'),
    fileEl = $('#ldm-file'),
    fileNameEl = $('#ldm-file-name'),
    fileRemoveEl = $('#ldm-file-remove'),
    pdfEl = $('#ldm-pdf'),
    pdfPageEl = $('#ldm-pdf-page'),
    qtyEl = $('#ldm-qty'),
    qtyMainEl = $('#ldm-qty-main'),
    specialRequestsEl = $('#ldm-special-requests'),
    specialRequestsWrap = $('#ldm-special-requests-wrap'),
    specialToggleEl = $('#ldm-special-toggle'),
    threadNoteEl = $('#ldm-thread-note'),
    threadNoteButton = $('#ldm-thread-note-button'),
    specialToggleLabel = $('#ldm-special-toggle-label');
  function setSpecialRequestsExpanded(expanded, focus = !1) {
    !specialRequestsWrap ||
      !specialToggleEl ||
      (specialRequestsWrap.classList.toggle('expanded', expanded),
      specialToggleEl.setAttribute('aria-expanded', String(expanded)),
      threadNoteButton && threadNoteButton.setAttribute('aria-expanded', String(expanded)),
      specialToggleLabel && (specialToggleLabel.textContent = expanded ? 'Hide special requests' : 'Add special requests'),
      expanded && focus && specialRequestsEl && specialRequestsEl.focus());
  }
  (specialToggleEl && specialRequestsWrap && (specialToggleEl.onclick = () => setSpecialRequestsExpanded(!specialRequestsWrap.classList.contains('expanded'), !0)),
    threadNoteButton && (threadNoteButton.onclick = () => openTintPop(threadNoteButton)));
  const pricePerEl = $('#ldm-price-per'),
    saveEl = $('#ldm-save'),
    filePanel = $('#ldm-file-panel'),
    textPanel = $('#ldm-text-panel'),
    textInput = $('#ldm-text-input'),
    textFontWrap = $('#ldm-text-font-wrap'),
    textFontBtn = $('#ldm-text-font-btn'),
    textFontLabel = $('#ldm-text-font-label'),
    textFontMenu = $('#ldm-text-font-menu'),
    textPreview = $('#ldm-text-preview'),
    textRemoveBtn = $('#ldm-text-remove'),
    textCurveSlider = $('#ldm-text-curve'),
    textCurveOpt = $('#ldm-text-curve-opt'),
    totalEl = $('#ldm-total'),
    ctaEl = $('#ldm-cta'),
    saveToggleBtn = $('#ldm-save-toggle'),
    orderToggleBtn = $('#ldm-order-toggle'),
    savePanel = $('#ldm-save-design'),
    orderPanel = $('#ldm-order-design'),
    orderEmailInput = $('#ldm-order-email'),
    orderErrorEl = $('#ldm-order-error'),
    errorEl = $('#ldm-error'),
    modal = $('#ldm-modal'),
    processing = $('#ldm-processing'),
    uploadSuccessEl = $('#ldm-upload-success'),
    shareToast = $('#ldm-share-toast'),
    breakdownEl = $('#ldm-breakdown'),
    _preloaded = new Set();
  function preloadColorImages(color) {
    [state.side].forEach((side) => {
      const img = imageFor(color, side);
      if (img.url && !_preloaded.has(img.url)) {
        _preloaded.add(img.url);
        const p = new Image();
        ((p.fetchPriority = 'low'), (p.src = img.url));
      }
    });
  }
  function updateLeadTime() {
    const mainEl = document.getElementById('ldm-lead-main'),
      mobileEl = document.getElementById('ldm-lead-mobile'),
      prodEl = document.getElementById('ldm-lead-prod-val');
    (mainEl && (mainEl.textContent = '2–3 weeks after sample review'),
      mobileEl && (mobileEl.textContent = '2–3 weeks after sample review'),
      prodEl && (prodEl.textContent = '2–3 weeks'));
  }
  function setPreviewColor(color) {
    return COLORS.includes(color)
      ? (mixOn() && !state.mix.some((row) => row.color === color) ? (mixPreviewColor = color) : ((state.color = color), (mixPreviewColor = null)), !0)
      : !1;
  }
  function selectColor(color) {
    setPreviewColor(color) && (renderSwatches(), updateStage(), mixOn() && renderMix(), trackEvent('ColorSelected', { color }));
  }
  function renderSwatches() {
    const twotoneGroup = $('#ldm-twotone-group'),
      twotoneEl = $('#ldm-swatches-twotone');
    ((swatchesEl.innerHTML = ''), twotoneEl && (twotoneEl.innerHTML = ''));
    const mkSwatch = (color, container) => {
      const btn = document.createElement('button'),
        included = mixOn() && state.mix.some((row) => row.color === color);
      ((btn.type = 'button'),
        (btn.className = 'ldm-swatch' + (color === displayedColor() ? ' active' : '') + (included ? ' in-mix' : '')),
        (btn.dataset.color = color),
        btn.setAttribute('aria-pressed', String(color === displayedColor())),
        btn.setAttribute('aria-label', color),
        mixOn() && btn.setAttribute('aria-description', included ? 'In your order. Select to preview.' : 'Preview only. Use Add to mix to include this color.'));
      const safeColorName = color.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      ((btn.title = color),
        (btn.innerHTML = `<img src="${swatchImage(color)}" alt="${safeColorName}">`),
        (btn.onclick = () => {
          selectColor(color);
          const replacement = [...swatchesEl.querySelectorAll('button'), ...(twotoneEl ? twotoneEl.querySelectorAll('button') : [])].find(
            (button) => button.dataset.color === color,
          );
          replacement && replacement.focus({ preventScroll: !0 });
        }),
        (btn.onmouseenter = () => preloadColorImages(color)),
        container.appendChild(btn));
    };
    let hasTwoTone = !1;
    (COLORS.forEach((color) => {
      color.includes('/') && twotoneEl ? (mkSwatch(color, twotoneEl), (hasTwoTone = !0)) : mkSwatch(color, swatchesEl);
    }),
      twotoneGroup && (twotoneGroup.style.display = hasTwoTone ? '' : 'none'));
    const colorNameEl = $('#ldm-color-name');
    colorNameEl && (colorNameEl.textContent = displayedColor());
    const colorLabelEl = $('#ldm-color-label');
    (colorLabelEl && (colorLabelEl.textContent = mixOn() ? 'Previewing:' : 'Color:'), updateLeadTime());
  }
  function renderTabs() {
    $$('.ldm-tab', tabsEl).forEach((tab) => {
      const side = tab.dataset.side;
      tab.classList.toggle('active', side === state.side);
      const icon = tab.querySelector('.ldm-tab-icon'),
        hasDesign = !!state.designs[side].data;
      (icon.classList.toggle('done', hasDesign),
        tab.classList.toggle('has-design', hasDesign),
        (icon.innerHTML = hasDesign
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>'));
    });
  }
  tabsEl.onclick = (e) => {
    const tab = e.target.closest('.ldm-tab');
    tab &&
      ((state.side = tab.dataset.side), trackEvent('SideSwitched', { side: state.side }), syncInlineTextForSide(), renderTabs(), updateStage(), updateUploadUI(), syncViewBtns());
  };
  function syncViewBtns() {
    $$('.ldm-view-btn').forEach((btn) => btn.classList.toggle('active', btn.dataset.view === state.side));
  }
  function syncInlineTextForSide() {
    (closeColorEditor(), closeAllTextPopovers(), inlineTextEl.classList.remove('active'), (inlineTextInput.value = ''));
  }
  $$('.ldm-view-btn').forEach((btn) => {
    btn.onclick = () => {
      ((state.side = btn.dataset.view), syncInlineTextForSide(), syncViewBtns(), renderTabs(), updateStage(), updateUploadUI());
    };
  });
  function updateStage() {
++ldCapThreadPreviewSeq;

    const color = displayedColor(),
      img = imageFor(color, state.side);
    (stageImg.src !== img.url &&
      ((stageImg.style.opacity = '0'),
      (stageImg.onload = () => {
        requestAnimationFrame(() => {
          stageImg.style.opacity = '1';
        });
      }),
      (stageImg.onerror = () => {
        stageImg.style.opacity = '1';
      })),
      stageImg.src !== img.url && ((stageImg.srcset = [400, 800, 1200].map((width) => `${imageFor(color, state.side, width).url} ${width}w`).join(', ')), (stageImg.src = img.url)),
      (stageImg.alt = `Custom ${color || ''} cap mockup \u2014 ${state.side} view`.trim()),
      stageImg.classList.toggle('flip', img.flip));
    const d = state.designs[state.side],
      inlineActive = inlineTextEl.classList.contains('active');
    if (d.mode === 'text' && inlineActive) (logo.classList.remove('active', 'selected'), (logoImg.src = ''), stageBtns.classList.add('hidden'));
    else if (d.data) {
      ((void ldCapThreadPreview(d, color)),
        logo.classList.add('active'),
        logo.classList.toggle('ldm-mode-text', d.mode === 'text'),
        stageBtns.classList.add('hidden'),
        applyPlacement(d.placement),
        colorEditorDesign && (colorEditorDesign !== d || colorEditorMode !== d.mode || colorEditorSide !== state.side) && closeColorEditor());
      const cropSrc = d._fullEdited || d.data;
      if (d.mode !== 'text' && (!d._fullEditedImg || d._fullEditedImg.src !== cropSrc)) {
        const warm = new Image();
        ((warm.src = cropSrc), (d._fullEditedImg = warm));
      }
    } else ((logoImg.src = ''), logo.classList.remove('active', 'selected'), d.mode !== 'text' && closeColorEditor(), inlineActive || stageBtns.classList.remove('hidden'));
    updateInlineText();
  
syncThreadControls();
if (state.designs[state.side].mode === 'text') { applyInlineTextStyle(); updateTextPreview(); }
}
  function applyPlacement(p) {
    ((logo.style.left = p.x + '%'),
      (logo.style.top = p.y + '%'),
      (logo.style.transform = `translate(-50%, -50%) rotate(${p.r || 0}deg)`),
      (logoImg.style.width = p.w + 'px'),
      (logoImg.style.height = 'auto'));
  }
  function savePlacement() {
    const stageRect = stageEl.getBoundingClientRect(),
      logoRect = logo.getBoundingClientRect(),
      p = state.designs[state.side].placement,
      centerX = logoRect.left + logoRect.width / 2 - stageRect.left,
      centerY = logoRect.top + logoRect.height / 2 - stageRect.top;
    ((p.x = (centerX / stageRect.width) * 100), (p.y = (centerY / stageRect.height) * 100), (p.w = logoImg.offsetWidth));
  }
  function updateUploadUI() {
    const d = state.designs[state.side],
      mode = d.mode || 'file';
    (syncThreadControls(d),
      $$('.ldm-mode-btn').forEach((b) => b.classList.toggle('active', b.dataset.mode === mode)),
      (filePanel.style.display = mode === 'file' ? 'block' : 'none'),
      textPanel.classList.toggle('show', mode === 'text'));
    const removeBgBtn2 = $('#ldm-remove-bg');
    if (mode === 'file') {
      if (d.file) {
        ((uploadEl.style.display = 'none'), fileEl.classList.add('show'), (fileNameEl.textContent = d.file.name), uploadSuccessEl.classList.add('show'));
        const noteEl = document.querySelector('.ldm-upload-note');
        if ((noteEl && (noteEl.style.display = 'none'), removeBgBtn2)) {
          const isRaster = d.data && !d.data.startsWith('data:image/svg') && !/\.(ai|eps)$/i.test(d.file?.name || '');
          ((removeBgBtn2.style.display = isRaster ? 'inline-flex' : 'none'),
            removeBgBtn2.classList.remove('done', 'processing'),
            ($('#ldm-remove-bg-text').textContent = d._bgRemoved ? 'Background removed \u2713' : 'Remove background'),
            d._bgRemoved && removeBgBtn2.classList.add('done'));
        }
      } else {
        ((uploadEl.style.display = 'block'), fileEl.classList.remove('show'), uploadSuccessEl.classList.remove('show'), removeBgBtn2 && (removeBgBtn2.style.display = 'none'));
        const noteEl = document.querySelector('.ldm-upload-note');
        noteEl && (noteEl.style.display = '');
      }
      pdfEl.classList.toggle('show', d.file?.type === 'application/pdf');
    } else
      ((textInput.value = d.textConfig.text),
        textFontLabel && ((textFontLabel.textContent = d.textConfig.font), (textFontLabel.style.fontFamily = `'${d.textConfig.font}'`)),
        (textCurveSlider.value = d.textConfig.curve || 0),
        (textCurveOpt.style.display = state.side === 'Back' ? '' : 'none'),
        textRemoveBtn.classList.toggle('show', !!d.textConfig.text.trim()),
        updateTextPreview());
  }
  let pendingFile = null;
  ((uploadEl.onclick = () => uploadInput.click()),
    (uploadEl.ondragover = (e) => {
      (e.preventDefault(), e.stopPropagation(), (uploadEl.style.borderColor = 'var(--green-dark)'), (uploadEl.style.background = 'var(--green-light)'));
    }),
    (uploadEl.ondragleave = (e) => {
      (e.preventDefault(), e.stopPropagation(), (uploadEl.style.borderColor = ''), (uploadEl.style.background = ''));
    }),
    (uploadEl.ondrop = async (e) => {
      (e.preventDefault(), e.stopPropagation(), (uploadEl.style.borderColor = ''), (uploadEl.style.background = ''));
      const file = e.dataTransfer?.files?.[0];
      if (file) {
        if (file.size > MAX_FILE) {
          showError('File is too large \u2014 maximum size is 10 MB.');
          return;
        }
        await processFile(file);
      }
    }),
    (stageBtnUpload.onclick = () => {
      const d = state.designs[state.side];
      (((ldCapThreadMode(d, 'file'), d.mode = 'file')), updateUploadUI(), uploadInput.click());
    }),
    (stageBtnText.onclick = () => {
      const d = state.designs[state.side];
      (((ldCapThreadMode(d, 'text'), d.mode = 'text')),
        trackEvent('TextModeSelected', { side: state.side }),
        updateUploadUI(),
        openTintPop(null, { focus: !1, scroll: !1 }),
        stageBtns.classList.add('hidden'),
        inlineTextEl.classList.add('active'),
        (inlineTextInput.value = d.textConfig.text || ''),
        applyInlineTextStyle(),
        applyInlineTextPlacement(d.placement),
        setTimeout(() => inlineTextInput.focus(), 50));
    }));
  function applyInlineTextStyle() {
    const d = state.designs[state.side],
      tc = d.textConfig;
    (readyTextFonts.has(tc.font) ||
      loadTextFont(tc.font)
        .then(() => {
          d === state.designs[state.side] && d.mode === 'text' && resizeInlineTextInput();
        })
        .catch(() => {}),
      (inlineTextInput.style.fontFamily = `'${tc.font}', sans-serif`),
      (inlineTextInput.style.color = ldCapThreadChoice(d).hex || tc.color));
    const inlineSize = Math.round(((tc.size || 64) * 22) / 64);
    ((inlineTextInput.style.fontSize = inlineSize + 'px'), (inlineTextInput.style.textAlign = tc.align || 'center'), resizeInlineTextInput());
  }
  function resizeInlineTextInput() {
    inlineTextEl.classList.contains('active') && ((inlineTextInput.style.height = 'auto'), (inlineTextInput.style.height = inlineTextInput.scrollHeight + 2 + 'px'));
  }
  function applyInlineTextPlacement(p) {
    ((inlineTextEl.style.left = p.x + '%'), (inlineTextEl.style.top = p.y + '%'), (inlineTextEl.style.transform = `translate(-50%, -50%) rotate(${p.r || 0}deg)`));
  }
  function updateInlineText() {
    state.designs[state.side].mode === 'text' && inlineTextEl.classList.contains('active') && applyInlineTextStyle();
  }
  let _textDebounce = null;
  function debouncedApplyTextDesign() {
    clearTimeout(_textDebounce);
    const d = state.designs[state.side];
    _textDebounce = setTimeout(() => {
      ((_textDebounce = null), applyTextDesign(d));
    }, 150);
  }
  const MAX_TEXT_LINES = 4;
  function enforceMaxLines(el) {
    const lines = el.value.split(`
`);
    lines.length > MAX_TEXT_LINES &&
      (el.value = lines.slice(0, MAX_TEXT_LINES).join(`
`));
  }
  inlineTextInput.oninput = () => {
    enforceMaxLines(inlineTextInput);
    const d = state.designs[state.side];
    ((d.textConfig.text = inlineTextInput.value), (textInput.value = inlineTextInput.value), resizeInlineTextInput(), debouncedApplyTextDesign());
  };
  function finishInlineText(restoreFocus = !1) {
    if (!inlineTextEl.classList.contains('active')) return;
    _textDebounce !== null && (clearTimeout(_textDebounce), (_textDebounce = null), applyTextDesign());
    const d = state.designs[state.side];
    (inlineTextEl.classList.remove('active'), updateStage(), restoreFocus && (d.textConfig.text.trim() ? textInput : stageBtnText).focus({ preventScroll: !0 }));
  }
  (inlineTextEl.addEventListener('focusout', (e) => {
    inlineTextEl.contains(e.relatedTarget) || finishInlineText();
  }),
    window.addEventListener('resize', resizeInlineTextInput, { passive: !0 }),
    inlineTextDone && (inlineTextDone.onclick = () => finishInlineText(!0)),
    inlineTextEl.addEventListener('keydown', (e) => {
      e.key === 'Escape' && (e.preventDefault(), e.stopPropagation(), finishInlineText(!0));
    }));
  let inlineDrag = null;
  ((inlineTextEl.onpointerdown = (e) => {
    if (e.target === inlineTextInput || e.target.closest('button')) return;
    (e.preventDefault(), e.stopPropagation(), inlineTextEl.setPointerCapture(e.pointerId));
    const stageRect = stageEl.getBoundingClientRect(),
      elRect = inlineTextEl.getBoundingClientRect();
    inlineDrag = { sx: e.clientX, sy: e.clientY, startX: elRect.left + elRect.width / 2 - stageRect.left, startY: elRect.top + elRect.height / 2 - stageRect.top };
  }),
    (inlineTextEl.onpointermove = (e) => {
      if (!inlineDrag) return;
      const stageRect = stageEl.getBoundingClientRect();
      let newX = clamp(inlineDrag.startX + e.clientX - inlineDrag.sx, 30, stageRect.width - 30),
        newY = clamp(inlineDrag.startY + e.clientY - inlineDrag.sy, 30, stageRect.height - 30);
      ((inlineTextEl.style.left = (newX / stageRect.width) * 100 + '%'), (inlineTextEl.style.top = (newY / stageRect.height) * 100 + '%'));
    }),
    (inlineTextEl.onpointerup = () => {
      if (inlineDrag) {
        const stageRect = stageEl.getBoundingClientRect(),
          elRect = inlineTextEl.getBoundingClientRect(),
          d = state.designs[state.side];
        ((d.placement.x = ((elRect.left + elRect.width / 2 - stageRect.left) / stageRect.width) * 100),
          (d.placement.y = ((elRect.top + elRect.height / 2 - stageRect.top) / stageRect.height) * 100),
          (inlineDrag = null));
      }
    }),
    (stageEl.onclick = (e) => {
      !e.target.closest('.ldm-artwork-controls, .ldm-thread-trigger--stage') &&
        !e.target.closest('.ldm-logo') &&
        !e.target.closest('.ldm-stage-btn') &&
        !e.target.closest('.ldm-stage-btns') &&
        !e.target.closest('.ldm-inline-text') &&
        logo.classList.remove('selected');
    }),
    (uploadInput.onchange = async () => {
      const file = uploadInput.files[0];
      if (((uploadInput.value = ''), !!file)) {
        if (file.size > MAX_FILE) {
          showError('File is too large \u2014 maximum size is 10 MB.');
          return;
        }
        await processFile(file);
      }
    }),
    ($('#ldm-modal-close').onclick = () => {
      (modal.classList.remove('show'), (pendingFile = null));
    }),
    ($('#ldm-modal-vector').onclick = () => {
      (modal.classList.remove('show'), (pendingFile = null), uploadInput.click());
    }),
    ($('#ldm-modal-continue').onclick = async () => {
      (modal.classList.remove('show'), pendingFile && (await processFile(pendingFile), (pendingFile = null)));
    }),
    (modal.onclick = (e) => {
      e.target === modal && (modal.classList.remove('show'), (pendingFile = null));
    }));
  async function processFile(file) {
    const side = state.side,
      d = state.designs[side],
      uploadSeq = (d._uploadSeq = (d._uploadSeq || 0) + 1);
    try {
      let dataUrl;
      const isAiOrEps = /\.(ai|eps)$/i.test(file.name);
      if (((isAiOrEps || file.type === 'application/pdf') && (await ensurePdfJs()), isAiOrEps))
        try {
          dataUrl = await processPDF(file, 0);
        } catch {
          dataUrl = generatePlaceholder(file.name);
        }
      else if (file.type === 'application/pdf') {
        const pdfBuf = await file.arrayBuffer();
        dataUrl = await processPDFFromBuffer(pdfBuf, 0);
        const count = await getPDFPageCountFromBuffer(pdfBuf);
        (count > 1 && (pdfPageEl.innerHTML = Array.from({ length: count }, (_, i) => `<option value="${i}">Page ${i + 1}</option>`).join('')), (d._pdfBuffer = pdfBuf));
      } else file.type === 'image/svg+xml' ? (dataUrl = await processSVG(file)) : (dataUrl = await fileToDataURL(file));
      if (d._uploadSeq !== uploadSeq) return;
      (d.mode === 'text' ? ((d._stashedFile = file), (d._stashedData = dataUrl), (d._stashedBgRemoved = !1)) : ((d.file = file), (d.data = dataUrl)),
        (d.pdfPage = 0),
        (d._bgRemoved = !1),
        (d._fullBase = null),
        (d._fullEdited = null),
        (d._fullEditedImg = null),
        (d._cropRect = null),
        ((d._tint = null, ldCapThreadResetFile(d))),
        state.side === side && (updateUploadUI(), updateStage(), d.mode !== 'text' && openTintPop(null)),
        renderTabs(),
        updatePricing(),
        hideError(),
        warmBgModel(),
        trackEvent('DesignUploaded', { side, fileType: file.type, fileName: file.name }));
    } catch (e) {
      (console.error('[processFile] failed:', e), showError("We couldn't process that file. Please try a PNG or JPG under 10 MB."));
    }
  }
  function generatePlaceholder(filename) {
    const ext = filename.split('.').pop().toUpperCase(),
      c = document.createElement('canvas');
    ((c.width = 240), (c.height = 240));
    const ctx = c.getContext('2d');
    return (
      (ctx.fillStyle = '#f3f4f6'),
      ctx.beginPath(),
      ctx.roundRect(0, 0, 240, 240, 12),
      ctx.fill(),
      (ctx.strokeStyle = '#d1d5db'),
      (ctx.lineWidth = 2),
      ctx.beginPath(),
      ctx.roundRect(1, 1, 238, 238, 12),
      ctx.stroke(),
      (ctx.fillStyle = '#9ca3af'),
      (ctx.font = '600 14px -apple-system, BlinkMacSystemFont, sans-serif'),
      (ctx.textAlign = 'center'),
      ctx.fillText('Design uploaded', 120, 105),
      (ctx.fillStyle = '#6b7280'),
      (ctx.font = 'bold 28px -apple-system, BlinkMacSystemFont, sans-serif'),
      ctx.fillText('.' + ext.toLowerCase(), 120, 145),
      c.toDataURL('image/png')
    );
  }
  let designActionDialog = null,
    pendingDesignAction = null;
  function confirmDesignAction({ title, message, confirmLabel, cancelLabel }) {
    return pendingDesignAction
      ? Promise.resolve(!1)
      : (designActionDialog ||
          ((designActionDialog = document.createElement('dialog')),
          (designActionDialog.className = 'ldm-design-dialog'),
          designActionDialog.setAttribute('aria-labelledby', 'ldm-design-dialog-title'),
          designActionDialog.setAttribute('aria-describedby', 'ldm-design-dialog-message'),
          designActionDialog.setAttribute('aria-modal', 'true'),
          (designActionDialog.innerHTML = `
                <div class="ldm-design-dialog__content">
                  <p class="ldm-design-dialog__eyebrow">Your design</p>
                  <h2 class="ldm-design-dialog__title" id="ldm-design-dialog-title"></h2>
                  <p class="ldm-design-dialog__message" id="ldm-design-dialog-message"></p>
                  <div class="ldm-design-dialog__actions">
                    <button type="button" class="ldm-design-dialog__button ldm-design-dialog__button--cancel" autofocus></button>
                    <button type="button" class="ldm-design-dialog__button ldm-design-dialog__button--confirm"></button>
                  </div>
                </div>`),
          document.body.appendChild(designActionDialog),
          (designActionDialog.querySelector('.ldm-design-dialog__button--cancel').onclick = () => designActionDialog.close('cancel')),
          (designActionDialog.querySelector('.ldm-design-dialog__button--confirm').onclick = () => designActionDialog.close('confirm')),
          designActionDialog.addEventListener('cancel', (event) => {
            (event.preventDefault(), designActionDialog.close('cancel'));
          }),
          designActionDialog.addEventListener('click', (event) => {
            if (event.target !== designActionDialog) return;
            const bounds = designActionDialog.getBoundingClientRect();
            (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) && designActionDialog.close('cancel');
          }),
          designActionDialog.addEventListener('close', () => {
            const pending = pendingDesignAction;
            ((pendingDesignAction = null),
              pending &&
                (pending.trigger?.isConnected && pending.trigger.getClientRects().length && pending.trigger.focus({ preventScroll: !0 }),
                pending.resolve(designActionDialog.returnValue === 'confirm')));
          })),
        (designActionDialog.querySelector('.ldm-design-dialog__title').textContent = title),
        (designActionDialog.querySelector('.ldm-design-dialog__message').textContent = message),
        (designActionDialog.querySelector('.ldm-design-dialog__button--cancel').textContent = cancelLabel),
        (designActionDialog.querySelector('.ldm-design-dialog__button--confirm').textContent = confirmLabel),
        (designActionDialog.returnValue = ''),
        new Promise((resolve) => {
          pendingDesignAction = { resolve, trigger: document.activeElement };
          try {
            (designActionDialog.showModal(), designActionDialog.querySelector('.ldm-design-dialog__button--cancel').focus({ preventScroll: !0 }));
          } catch {
            ((pendingDesignAction = null), showError('We couldn\u2019t open the confirmation. Please refresh the page and try again.'), resolve(!1));
          }
        }));
  }
  async function removeDesign(skipConfirm) {
    const side = state.side,
      d = state.designs[side],
      original = { data: d.data, file: d.file, mode: d.mode, text: JSON.stringify(d.textConfig), stashedFile: d._stashedFile, stashedData: d._stashedData };
    if (!skipConfirm && d.data) {
      const isText = d.mode === 'text';
      if (
        !(await confirmDesignAction({
          title: isText ? 'Remove this text?' : 'Remove this image?',
          message: `This clears the design on the ${side.toLowerCase()} of your cap. Your other sides will stay as they are.`,
          confirmLabel: isText ? 'Remove text' : 'Remove image',
          cancelLabel: 'Keep design',
        })) ||
        state.side !== side ||
        state.designs[side] !== d ||
        d.mode !== original.mode ||
        d.file !== original.file ||
        JSON.stringify(d.textConfig) !== original.text ||
        d._stashedFile !== original.stashedFile ||
        d._stashedData !== original.stashedData ||
        (d.mode !== 'text' && d.data !== original.data)
      )
        return !1;
    }
    (Object.assign(d, {threadByColor: {}, threadSource: null, defaultTint: null, _fileThreadState: null, _textThreadByColor: null, 
      file: null,
      data: null,
      placement: { ...(PLACEMENT_DEFAULTS[side] || PLACEMENT_DEFAULTS.Front) },
      mode: 'file',
      textConfig: { text: '', font: 'DM Sans', color: '#FFFFFF', size: 64, align: 'center', curve: 0 },
      _bgRemoved: !1,
      _stashedFile: null,
      _stashedData: null,
      _stashedBgRemoved: null,
      _fullBase: null,
      _fullEdited: null,
      _fullEditedImg: null,
      _cropRect: null,
      _tint: null,
      _editSeq: (d._editSeq || 0) + 1,
      _uploadSeq: (d._uploadSeq || 0) + 1,
    }),
      (uploadInput.value = ''),
      (logoImg.src = ''),
      logo.classList.remove('active', 'selected'),
      inlineTextEl.classList.remove('active'),
      (inlineTextInput.value = ''),
      stageBtns.classList.remove('hidden'),
      uploadSuccessEl.classList.remove('show'));
    const _tp = document.getElementById('ldm-tint-pop');
    return (_tp && (_tp.hidden = !0), updateUploadUI(), renderTabs(), updatePricing(), !skipConfirm && original.data && stageBtnUpload.focus({ preventScroll: !0 }), !0);
  }
  pdfPageEl.onchange = async () => {
    const d = state.designs[state.side];
    d.file &&
      ((d.pdfPage = parseInt(pdfPageEl.value)),
      d._pdfBuffer ? (d.data = await processPDFFromBuffer(d._pdfBuffer, d.pdfPage)) : (d.data = await processPDF(d.file, d.pdfPage)),
      (ldCapThreadResetFile(d), d._fullBase = null, d._fullEdited = null, d._fullEditedImg = null, d._cropRect = null, d._tint = null, updateStage()));
  };
  const TEXT_FONTS = [
      { value: 'DM Sans', label: 'DM Sans', weight: '700' },
      { value: 'Inter', label: 'Inter', weight: '700' },
      { value: 'Roboto', label: 'Roboto', weight: '700' },
      { value: 'Open Sans', label: 'Open Sans', weight: '700' },
      { value: 'Montserrat', label: 'Montserrat', weight: '800' },
      { value: 'Poppins', label: 'Poppins', weight: '700' },
      { value: 'Lato', label: 'Lato', weight: '900' },
      { value: 'Raleway', label: 'Raleway', weight: '800' },
      { value: 'Nunito', label: 'Nunito', weight: '800' },
      { value: 'Work Sans', label: 'Work Sans', weight: '800' },
      { value: 'Rubik', label: 'Rubik', weight: '700' },
      { value: 'Quicksand', label: 'Quicksand', weight: '700' },
      { value: 'Bebas Neue', label: 'Bebas Neue', weight: '400' },
      { value: 'Oswald', label: 'Oswald', weight: '700' },
      { value: 'Anton', label: 'Anton', weight: '400' },
      { value: 'Archivo Black', label: 'Archivo Black', weight: '400' },
      { value: 'Russo One', label: 'Russo One', weight: '400' },
      { value: 'Squada One', label: 'Squada One', weight: '400' },
      { value: 'Bowlby One', label: 'Bowlby One', weight: '400' },
      { value: 'Alfa Slab One', label: 'Alfa Slab One', weight: '400' },
      { value: 'Bungee', label: 'Bungee', weight: '400' },
      { value: 'Fugaz One', label: 'Fugaz One', weight: '400' },
      { value: 'Righteous', label: 'Righteous', weight: '400' },
      { value: 'Black Ops One', label: 'Black Ops One', weight: '400' },
      { value: 'Lilita One', label: 'Lilita One', weight: '400' },
      { value: 'Carter One', label: 'Carter One', weight: '400' },
      { value: 'Passion One', label: 'Passion One', weight: '700' },
      { value: 'Fredoka One', label: 'Fredoka One', weight: '400' },
      { value: 'Acme', label: 'Acme', weight: '400' },
      { value: 'Audiowide', label: 'Audiowide', weight: '400' },
      { value: 'Press Start 2P', label: 'Press Start 2P', weight: '400' },
      { value: 'Playfair Display', label: 'Playfair Display', weight: '700' },
      { value: 'Merriweather', label: 'Merriweather', weight: '900' },
      { value: 'Lora', label: 'Lora', weight: '700' },
      { value: 'Roboto Slab', label: 'Roboto Slab', weight: '700' },
      { value: 'Abril Fatface', label: 'Abril Fatface', weight: '400' },
      { value: 'Yeseva One', label: 'Yeseva One', weight: '400' },
      { value: 'Cinzel', label: 'Cinzel', weight: '700' },
      { value: 'Lobster', label: 'Lobster', weight: '400' },
      { value: 'Pacifico', label: 'Pacifico', weight: '400' },
      { value: 'Dancing Script', label: 'Dancing Script', weight: '700' },
      { value: 'Great Vibes', label: 'Great Vibes', weight: '400' },
      { value: 'Sacramento', label: 'Sacramento', weight: '400' },
      { value: 'Satisfy', label: 'Satisfy', weight: '400' },
      { value: 'Cookie', label: 'Cookie', weight: '400' },
      { value: 'Permanent Marker', label: 'Permanent Marker', weight: '400' },
      { value: 'Caveat', label: 'Caveat', weight: '700' },
      { value: 'Shadows Into Light', label: 'Shadows Into Light', weight: '400' },
      { value: 'Indie Flower', label: 'Indie Flower', weight: '400' },
      { value: 'Amatic SC', label: 'Amatic SC', weight: '700' },
      { value: 'Kalam', label: 'Kalam', weight: '700' },
      { value: 'Special Elite', label: 'Special Elite', weight: '400' },
    ],
    textFontLoads = new Map(),
    readyTextFonts = new Set();
  let fontMenuObserver;
  function loadTextFont(font) {
    const fd = TEXT_FONTS.find((f) => f.value === font) || TEXT_FONTS[0];
    if (textFontLoads.has(fd.value)) return textFontLoads.get(fd.value);
    const link = document.createElement('link');
    ((link.rel = 'stylesheet'), (link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fd.value)}:wght@${fd.weight}&display=swap`));
    const promise = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Font loading timed out')), 15e3);
      ((link.onload = () => {
        document.fonts.load(`${fd.weight} 64px "${fd.value}"`).then(
          (faces) => {
            if ((clearTimeout(timer), !faces.length)) {
              reject(new Error('Font unavailable'));
              return;
            }
            (readyTextFonts.add(fd.value), resolve());
          },
          (error) => {
            (clearTimeout(timer), reject(error));
          },
        );
      }),
        (link.onerror = () => {
          (clearTimeout(timer), reject(new Error('Font unavailable')));
        }),
        document.head.appendChild(link));
    }).catch((error) => {
      throw (link.remove(), textFontLoads.delete(fd.value), error);
    });
    return (textFontLoads.set(fd.value, promise), promise);
  }
  function observeFontMenu() {
    (fontMenuObserver?.disconnect(),
      !(!textFontWrap.classList.contains('open') || !('IntersectionObserver' in window)) &&
        ((fontMenuObserver = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) entry.isIntersecting && (fontMenuObserver.unobserve(entry.target), loadTextFont(entry.target.dataset.font).catch(() => {}));
          },
          { root: textFontMenu, rootMargin: '40px' },
        )),
        textFontMenu.querySelectorAll('[data-font]').forEach((option) => fontMenuObserver.observe(option))));
  }
  function renderFontMenu(active) {
    ((textFontMenu.innerHTML = TEXT_FONTS.map(
      (f) =>
        `<button type="button" class="ldm-text-font-opt${f.value === active ? ' active' : ''}" data-font="${f.value}" style="font-family:'${f.value}';font-weight:${f.weight}">${f.label}</button>`,
    ).join('')),
      observeFontMenu());
  }
  (renderFontMenu('DM Sans'),
    (textFontBtn.onclick = (e) => {
      e.stopPropagation();
      const open = textFontWrap.classList.contains('open');
      (closeAllTextPopovers(), open || (textFontWrap.classList.add('open'), textFontBtn.setAttribute('aria-expanded', 'true'), observeFontMenu()));
    }),
    textFontMenu.addEventListener('click', (e) => {
      const opt = e.target.closest('.ldm-text-font-opt');
      opt && (e.stopPropagation(), applyFont(opt.dataset.font), renderFontMenu(opt.dataset.font), closeAllTextPopovers());
    }));
  function applyFont(font) {
    const d = state.designs[state.side],
      fd = TEXT_FONTS.find((f) => f.value === font) || TEXT_FONTS[0];
    ((d.textConfig.font = fd.value),
      textFontLabel && ((textFontLabel.textContent = fd.value), (textFontLabel.style.fontFamily = `'${fd.value}'`)),
      applyInlineTextStyle(),
      applyTextDesign(d));
  }
  async function prepareTextDesigns() {
    (clearTimeout(_textDebounce), (_textDebounce = null));
    for (const d of Object.values(state.designs)) d.mode !== 'text' || !d.textConfig.text.trim() || (await loadTextFont(d.textConfig.font), applyTextDesign(d));
  }
  function applyTextColor(color) {
    if (!/^#[0-9A-F]{6}$/i.test(color)) return !1;
    const d = state.designs[state.side];
    return d.mode !== 'text'
      ? !1
      : ((d.textConfig.color = color.toUpperCase()),
        syncThreadControls(d),
        applyInlineTextStyle(),
        d.textConfig.text.trim() ? applyTextDesign(d) : updateTextPreview(),
        autoSave(),
        !0);
  }
  function closeAllTextPopovers() {
    (fontMenuObserver?.disconnect(), textFontWrap && (textFontWrap.classList.remove('open'), textFontBtn.setAttribute('aria-expanded', 'false')));
  }
  (document.addEventListener('click', (e) => {
    e.target.closest('#ldm-text-font-wrap') || closeAllTextPopovers();
  }),
    document.addEventListener('keydown', (e) => {
      e.key === 'Escape' && closeAllTextPopovers();
    }));
  function renderTextToDataURL(text, font, color, size, align, curve) {
    if (curve && curve !== 0) return renderCurvedTextToDataURL(text, font, color, size, curve);
    const fontDef = TEXT_FONTS.find((f) => f.value === font) || TEXT_FONTS[0],
      c = document.createElement('canvas'),
      ctx = c.getContext('2d'),
      dpr = Math.max(window.devicePixelRatio || 1, 2),
      fontSize = (size || 64) * dpr,
      textAlign = align || 'center',
      lineHeight = fontSize * 1.4,
      pad = 20 * dpr,
      lines = text.split(`
`);
    ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`;
    let maxWidth = 0;
    for (const line of lines) {
      const w = ctx.measureText(line || ' ').width;
      w > maxWidth && (maxWidth = w);
    }
    ((c.width = Math.ceil(maxWidth) + pad * 2),
      (c.height = Math.ceil(lineHeight * lines.length) + pad * 2),
      (ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`),
      (ctx.fillStyle = color),
      (ctx.textAlign = textAlign),
      (ctx.textBaseline = 'middle'));
    const startY = pad + lineHeight / 2,
      drawX = textAlign === 'left' ? pad : textAlign === 'right' ? c.width - pad : c.width / 2;
    for (let i = 0; i < lines.length; i++) ctx.fillText(lines[i], drawX, startY + i * lineHeight);
    return c.toDataURL('image/png');
  }
  function renderCurvedTextToDataURL(text, font, color, size, curve) {
    const fontDef = TEXT_FONTS.find((f) => f.value === font) || TEXT_FONTS[0],
      c = document.createElement('canvas'),
      ctx = c.getContext('2d'),
      dpr = Math.max(window.devicePixelRatio || 1, 2),
      fontSize = (size || 64) * dpr,
      pad = 40 * dpr,
      lines = text.split(`
`),
      curveDir = curve > 0 ? 1 : -1,
      curveAmt = Math.abs(curve) / 100;
    ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`;
    const lineWidths = lines.map((l) => ctx.measureText(l || ' ').width),
      maxWidth = Math.max(...lineWidths),
      lineHeight = fontSize * 1.5,
      minRadius = maxWidth * 0.6,
      maxRadius = maxWidth * 4,
      radius = maxRadius - (maxRadius - minRadius) * curveAmt,
      totalArcHeight = radius - Math.sqrt(Math.max(0, radius * radius - (maxWidth / 2) * (maxWidth / 2))) + fontSize,
      canvasW = Math.ceil(maxWidth + pad * 2),
      canvasH = Math.ceil(totalArcHeight * lines.length + pad * 2 + fontSize);
    ((c.width = canvasW),
      (c.height = canvasH),
      (ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`),
      (ctx.fillStyle = color),
      (ctx.textAlign = 'center'),
      (ctx.textBaseline = 'middle'));
    for (let li = 0; li < lines.length; li++) {
      const line = lines[li];
      if (!line) continue;
      const chars = [...line],
        charWidths = chars.map((ch) => ctx.measureText(ch).width),
        totalAngle = charWidths.reduce((a, b) => a + b, 0) / radius,
        cx = canvasW / 2,
        cy =
          curveDir > 0 ? pad + radius + fontSize / 2 + li * (totalArcHeight + lineHeight * 0.2) : canvasH - pad - radius - fontSize / 2 - li * (totalArcHeight + lineHeight * 0.2);
      let currentAngle = -totalAngle / 2;
      for (let i = 0; i < chars.length; i++) {
        const halfChar = charWidths[i] / 2;
        currentAngle += halfChar / radius;
        const drawAngle = curveDir > 0 ? -Math.PI / 2 + currentAngle : Math.PI / 2 - currentAngle,
          x = cx + radius * Math.cos(drawAngle),
          y = cy + radius * Math.sin(drawAngle);
        (ctx.save(),
          ctx.translate(x, y),
          ctx.rotate(drawAngle + (curveDir > 0 ? Math.PI / 2 : -Math.PI / 2)),
          ctx.fillText(chars[i], 0, 0),
          ctx.restore(),
          (currentAngle += halfChar / radius));
      }
    }
    return c.toDataURL('image/png');
  }
  function applyTextDesign(d = state.designs[state.side]) {
    if (d.mode !== 'text') return;
    const tc = d.textConfig;
    if (((tc.font = (TEXT_FONTS.find((f) => f.value === tc.font) || TEXT_FONTS[0]).value), !tc.text.trim())) {
      if ((d.mode === 'text' && ((d.data = null), (d.file = null)), renderTabs(), updatePricing(), d !== state.designs[state.side])) {
        autoSave();
        return;
      }
      (updateStage(), updateTextPreview(), textRemoveBtn.classList.remove('show'));
      return;
    }
    if (!readyTextFonts.has(tc.font)) {
      if (d._pendingTextFont === tc.font) return;
      ((d._pendingTextFont = tc.font),
        loadTextFont(tc.font)
          .then(() => {
            ((d._pendingTextFont = null), applyTextDesign(d));
          })
          .catch(() => {
            ((d._pendingTextFont = null),
              d === state.designs[state.side] && d.mode === 'text' && showError('The font could not load. Please select it again or choose another font.'));
          }));
      return;
    }
    if (
      ((d.data = renderTextToDataURL(tc.text, tc.font, tc.color, tc.size, tc.align, tc.curve)), (d.file = null), renderTabs(), updatePricing(), d !== state.designs[state.side])
    ) {
      autoSave();
      return;
    }
    (updateStage(), updateTextPreview(), textRemoveBtn.classList.add('show'));
  }
  function updateTextPreview() {
    const tc = state.designs[state.side].textConfig;
    if (tc.text.trim()) {
      const safeText = tc.text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/\n/g, '<br>'),
        fontDef = TEXT_FONTS.find((f) => f.value === tc.font),
        safeFont = fontDef ? fontDef.value : TEXT_FONTS[0].value,
        safeColor = ldCapThreadChoice(state.designs[state.side]).hex || '#FFFFFF';
      textPreview.innerHTML = `<span class="ldm-text-preview-text" style="font-family:'${safeFont}';color:${safeColor};font-size:22px;font-weight:700;text-shadow:0 0 1px rgba(0,0,0,0.15);">${safeText}</span>`;
    } else textPreview.innerHTML = '<span class="ldm-text-preview-text" style="color:#999;">Type to preview</span>';
  }
  ($$('.ldm-mode-btn').forEach((btn) => {
    btn.onclick = () => {
      const mode = btn.dataset.mode,
        d = state.designs[state.side];
      if (d.mode === mode) {
        mode === 'file' && uploadInput.click();
        return;
      }
      (closeColorEditor(),
        closeAllTextPopovers(),
        ((ldCapThreadMode(d, mode), d.mode = mode)),
        $$('.ldm-mode-btn').forEach((b) => b.classList.toggle('active', b.dataset.mode === mode)),
        mode === 'text'
          ? (d.file && ((d._stashedFile = d.file), (d._stashedData = d.data), (d._stashedBgRemoved = d._bgRemoved)),
            d.textConfig.text.trim() ? applyTextDesign(d) : (d.data = null),
            (textCurveOpt.style.display = state.side === 'Back' ? '' : 'none'),
            (textCurveSlider.value = d.textConfig.curve || 0),
            stageBtns.classList.add('hidden'),
            inlineTextEl.classList.add('active'),
            (inlineTextInput.value = d.textConfig.text || ''),
            applyInlineTextStyle(),
            applyInlineTextPlacement(d.placement),
            setTimeout(() => inlineTextInput.focus(), 50))
          : (inlineTextEl.classList.remove('active'),
            (inlineTextInput.value = ''),
            d._stashedFile
              ? ((d.file = d._stashedFile),
                (d.data = d._stashedData),
                (d._bgRemoved = d._stashedBgRemoved || !1),
                (d._stashedFile = null),
                (d._stashedData = null),
                (d._stashedBgRemoved = null))
              : d.file || (d.data = null)),
        updateUploadUI(),
        updateStage(),
        renderTabs(),
        updatePricing(),
        (mode === 'text' || d.data) && openTintPop(null, { focus: !1, scroll: !1 }));
    };
  }),
    (textInput.oninput = () => {
      enforceMaxLines(textInput);
      const d = state.designs[state.side];
      ((d.textConfig.text = textInput.value),
        inlineTextEl.classList.contains('active') && ((inlineTextInput.value = textInput.value), resizeInlineTextInput()),
        (textInput.style.height = 'auto'),
        (textInput.style.height = textInput.scrollHeight + 'px'),
        debouncedApplyTextDesign());
    }),
    (textCurveSlider.oninput = () => {
      const d = state.designs[state.side];
      ((d.textConfig.curve = parseInt(textCurveSlider.value) || 0), d.textConfig.text.trim() && debouncedApplyTextDesign());
    }),
    (textRemoveBtn.onclick = () => removeDesign()));
  async function fileToDataURL(file) {
    const dataUrl = await new Promise((res, rej) => {
        const r = new FileReader();
        ((r.onload = () => res(r.result)), (r.onerror = rej), r.readAsDataURL(file));
      }),
      MAX_DIM = 2e3;
    return new Promise((resolve) => {
      const img = new Image();
      ((img.onload = () => {
        if (img.width <= MAX_DIM && img.height <= MAX_DIM) {
          resolve(dataUrl);
          return;
        }
        const c = document.createElement('canvas'),
          s = Math.min(MAX_DIM / img.width, MAX_DIM / img.height);
        ((c.width = Math.round(img.width * s)),
          (c.height = Math.round(img.height * s)),
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height),
          resolve(c.toDataURL('image/png')));
      }),
        (img.onerror = () => resolve(dataUrl)),
        (img.src = dataUrl));
    });
  }
  async function processPDF(file, page = 0) {
    const ab = await file.arrayBuffer();
    return processPDFFromBuffer(ab, page);
  }
  async function processPDFFromBuffer(ab, page = 0) {
    if (typeof pdfjsLib > 'u') throw new Error('PDF library not loaded');
    const pg = await (await pdfjsLib.getDocument({ data: ab.slice(0), isEvalSupported: !1, enableScripting: !1 }).promise).getPage(page + 1),
      vp = pg.getViewport({ scale: 2 }),
      c = document.createElement('canvas');
    return ((c.width = vp.width), (c.height = vp.height), await pg.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise, c.toDataURL('image/png'));
  }
  async function getPDFPageCount(file) {
    if (typeof pdfjsLib > 'u') return 1;
    const ab = await file.arrayBuffer();
    return getPDFPageCountFromBuffer(ab);
  }
  async function getPDFPageCountFromBuffer(ab) {
    return typeof pdfjsLib > 'u' ? 1 : (await pdfjsLib.getDocument({ data: ab.slice(0), isEvalSupported: !1, enableScripting: !1 }).promise).numPages;
  }
  function sanitizeSVG(raw) {
    let doc;
    try {
      doc = new DOMParser().parseFromString(raw, 'image/svg+xml');
    } catch {
      return '<svg xmlns="http://www.w3.org/2000/svg"/>';
    }
    if (doc.querySelector('parsererror')) return '<svg xmlns="http://www.w3.org/2000/svg"/>';
    doc.querySelectorAll('script,foreignObject,iframe,object,embed,audio,video,link,meta,style').forEach((el) => el.remove());
    const walker = document.createTreeWalker(doc.documentElement, NodeFilter.SHOW_ELEMENT),
      all = [];
    let node = walker.currentNode;
    for (; node; ) (all.push(node), (node = walker.nextNode()));
    for (const el of all)
      for (const attr of Array.from(el.attributes)) {
        const name = attr.name.toLowerCase();
        if (name.startsWith('on')) {
          el.removeAttribute(attr.name);
          continue;
        }
        if (name === 'href' || name === 'xlink:href') {
          const v = (attr.value || '').trim().toLowerCase();
          v.startsWith('#') || v.startsWith('data:image/') || el.removeAttribute(attr.name);
        }
        (/javascript:/i.test(attr.value) || /^https?:/i.test(attr.value)) && el.removeAttribute(attr.name);
      }
    return new XMLSerializer().serializeToString(doc);
  }
  async function processSVG(file) {
    const raw = await file.text(),
      txt = sanitizeSVG(raw),
      blob = new Blob([txt], { type: 'image/svg+xml' }),
      url = URL.createObjectURL(blob);
    return new Promise((res, rej) => {
      const img = new Image();
      ((img.onload = () => {
        const c = document.createElement('canvas');
        ((c.width = img.width || 800), (c.height = img.height || 800), c.getContext('2d').drawImage(img, 0, 0), URL.revokeObjectURL(url), res(c.toDataURL('image/png')));
      }),
        (img.onerror = () => {
          (URL.revokeObjectURL(url), rej(new Error('SVG error')));
        }),
        (img.src = url));
    });
  }
  let drag = null;
  const resizeHandle = $('#ldm-logo-resize');
  ((resizeHandle.onpointerdown = (e) => {
    (e.stopPropagation(), e.preventDefault(), resizeHandle.setPointerCapture(e.pointerId), (drag = { type: 'resize', sx: e.clientX, sy: e.clientY, sw: logoImg.offsetWidth }));
  }),
    (resizeHandle.onpointermove = (e) => {
      if (!drag || drag.type !== 'resize') return;
      e.stopPropagation();
      const delta = (e.clientX - drag.sx + e.clientY - drag.sy) / 2;
      logoImg.style.width = Math.min(stageEl.clientWidth * 0.9, Math.max(minLogoW(), drag.sw + delta)) + 'px';
    }),
    (resizeHandle.onpointerup = () => {
      drag?.type === 'resize' && (savePlacement(), (drag = null));
    }));
  const rotateHandle = $('#ldm-logo-rotate');
  ((rotateHandle.onpointerdown = (e) => {
    (e.stopPropagation(), e.preventDefault(), rotateHandle.setPointerCapture(e.pointerId));
    const logoRect = logo.getBoundingClientRect(),
      cx = logoRect.left + logoRect.width / 2,
      cy = logoRect.top + logoRect.height / 2;
    drag = { type: 'rotate', startAngle: (Math.atan2(e.clientY - cy, e.clientX - cx) * 180) / Math.PI, startRotation: state.designs[state.side].placement.r || 0 };
  }),
    (rotateHandle.onpointermove = (e) => {
      if (!drag || drag.type !== 'rotate') return;
      e.stopPropagation();
      const logoRect = logo.getBoundingClientRect(),
        cx = logoRect.left + logoRect.width / 2,
        cy = logoRect.top + logoRect.height / 2,
        currentAngle = (Math.atan2(e.clientY - cy, e.clientX - cx) * 180) / Math.PI,
        newRotation = drag.startRotation + (currentAngle - drag.startAngle);
      ((state.designs[state.side].placement.r = newRotation), (logo.style.transform = `translate(-50%, -50%) rotate(${newRotation}deg)`));
    }),
    (rotateHandle.onpointerup = () => {
      drag?.type === 'rotate' && (savePlacement(), (drag = null));
    }));
  function finishArtworkTransform() {
    (drag?.type !== 'rotate' && drag?.type !== 'resize') || (savePlacement(), (drag = null));
  }
  ([rotateHandle, resizeHandle].forEach((handle) => {
    (handle.addEventListener('pointercancel', finishArtworkTransform), handle.addEventListener('lostpointercapture', finishArtworkTransform));
  }),
    rotateHandle.addEventListener('keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home'].includes(e.key)) return;
      e.preventDefault();
      const p = state.designs[state.side].placement,
        step = e.shiftKey ? 15 : 1;
      ((p.r = e.key === 'Home' ? 0 : (p.r || 0) + (['ArrowLeft', 'ArrowDown'].includes(e.key) ? -step : step)),
        (logo.style.transform = `translate(-50%, -50%) rotate(${p.r}deg)`),
        savePlacement());
    }),
    resizeHandle.addEventListener('keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
      e.preventDefault();
      const delta = (e.shiftKey ? 10 : 2) * (['ArrowLeft', 'ArrowDown'].includes(e.key) ? -1 : 1);
      ((logoImg.style.width = Math.min(stageEl.clientWidth * 0.9, Math.max(minLogoW(), logoImg.offsetWidth + delta)) + 'px'), savePlacement());
    }));
  function loadImg(src) {
    return new Promise((res, rej) => {
      const i = new Image();
      ((i.onload = () => res(i)), (i.onerror = rej), (i.src = src));
    });
  }
  async function rebuildLogoData(d) {
    if (!d._fullBase) return;
    const base = d._fullBase,
      seq = (d._editSeq = (d._editSeq || 0) + 1);
    try {
      const full = await loadImg(base);
      if (seq !== d._editSeq || d._fullBase !== base) return;
      let fullEdited = base;
      if (d._tint) {
        const c = document.createElement('canvas');
        ((c.width = full.naturalWidth), (c.height = full.naturalHeight));
        const ctx = c.getContext('2d');
        (ctx.drawImage(full, 0, 0),
          (ctx.globalCompositeOperation = 'source-in'),
          (ctx.fillStyle = d._tint),
          ctx.fillRect(0, 0, c.width, c.height),
          (fullEdited = c.toDataURL('image/png')));
      }
      const r = d._cropRect;
      let out = fullEdited;
      if (r && (r.x > 0 || r.y > 0 || r.w < full.naturalWidth || r.h < full.naturalHeight)) {
        const src = d._tint ? await loadImg(fullEdited) : full,
          c2 = document.createElement('canvas');
        ((c2.width = r.w), (c2.height = r.h), c2.getContext('2d').drawImage(src, r.x, r.y, r.w, r.h, 0, 0, r.w, r.h), (out = c2.toDataURL('image/png')));
      } else d._cropRect = null;
      if (seq !== d._editSeq || d._fullBase !== base) return;
      if (((d._fullEdited = fullEdited), fullEdited === d._fullBase)) d._fullEditedImg = full;
      else {
        const warm = new Image();
        ((warm.src = fullEdited), (d._fullEditedImg = warm));
      }
      (d.mode === 'text' ? (d._stashedData = out) : (d.data = out), (_lastSavedHash = null));
    } catch (e) {
      console.error('[logo-edit] rebuild failed:', e);
    }
  }
  function applyCropMove(g, clientX, clientY) {
    const dx = clientX - g.sx,
      dy = clientY - g.sy,
      lx = dx * Math.cos(g.th) + dy * Math.sin(g.th),
      ly = -dx * Math.sin(g.th) + dy * Math.cos(g.th),
      KEEP = 24,
      i = g.ins,
      i0 = g.ins0;
    g.edge === 'left'
      ? (i.left = clamp(i0.left + lx, 0, g.fullW - i.right - KEEP))
      : g.edge === 'right'
        ? (i.right = clamp(i0.right - lx, 0, g.fullW - i.left - KEEP))
        : g.edge === 'top'
          ? (i.top = clamp(i0.top + ly, 0, g.fullH - i.bottom - KEEP))
          : g.edge === 'bottom' && (i.bottom = clamp(i0.bottom - ly, 0, g.fullH - i.top - KEEP));
    const vx = i.left + (g.fullW - i.left - i.right) / 2 - g.fullW / 2,
      vy = i.top + (g.fullH - i.top - i.bottom) / 2 - g.fullH / 2,
      ncx = g.fullCx + vx * Math.cos(g.th) - vy * Math.sin(g.th),
      ncy = g.fullCy + vx * Math.sin(g.th) + vy * Math.cos(g.th);
    ((logo.style.left = (ncx / g.stageRect.width) * 100 + '%'),
      (logo.style.top = (ncy / g.stageRect.height) * 100 + '%'),
      (logo.style.width = g.fullW - i.left - i.right + 'px'),
      (logo.style.height = g.fullH - i.top - i.bottom + 'px'),
      (logoImg.style.left = -i.left + 'px'),
      (logoImg.style.top = -i.top + 'px'),
      (logoImg.style.clipPath = `inset(${i.top}px ${i.right}px ${i.bottom}px ${i.left}px)`));
  }
  $$('.ldm-logo-crop').forEach((h) => {
    ((h.onpointerdown = async (e) => {
      (e.stopPropagation(), e.preventDefault());
      const d = state.designs[state.side];
      if (!d.data || d.mode === 'text') return;
      try {
        h.setPointerCapture(e.pointerId);
      } catch {}
      (d._fullBase || ((d._fullBase = d.data), (d._fullEdited = d.data), (d._cropRect = null)), d._fullEdited || (d._fullEdited = d._fullBase));
      const myDrag = { type: 'crop-pending', edge: h.dataset.edge, sx: e.clientX, sy: e.clientY };
      drag = myDrag;
if (d._threadBaselineReady) { await d._threadBaselineReady; if (drag !== myDrag) return; }

      let full = d._fullEditedImg && d._fullEditedImg.src === d._fullEdited && d._fullEditedImg.complete && d._fullEditedImg.naturalWidth ? d._fullEditedImg : null;
      if (!full) {
        try {
          full = await loadImg(d._fullEdited);
        } catch {
          drag === myDrag && (drag = null);
          return;
        }
        if (drag !== myDrag) return;
        d._fullEditedImg = full;
      }
      const natW = full.naturalWidth,
        natH = full.naturalHeight,
        rect = d._cropRect || { x: 0, y: 0, w: natW, h: natH },
        dispW = logoImg.offsetWidth;
      if (!dispW) {
        drag = null;
        return;
      }
      const sc = dispW / rect.w,
        fullW = natW * sc,
        fullH = natH * sc,
        p = d.placement,
        th = ((p.r || 0) * Math.PI) / 180,
        stageRect = stageEl.getBoundingClientRect(),
        cx = (p.x / 100) * stageRect.width,
        cy = (p.y / 100) * stageRect.height,
        offX = (rect.x + rect.w / 2 - natW / 2) * sc,
        offY = (rect.y + rect.h / 2 - natH / 2) * sc,
        fullCx = cx - (offX * Math.cos(th) - offY * Math.sin(th)),
        fullCy = cy - (offX * Math.sin(th) + offY * Math.cos(th)),
        ins = { top: rect.y * sc, left: rect.x * sc, right: (natW - rect.x - rect.w) * sc, bottom: (natH - rect.y - rect.h) * sc };
      ((logo.style.width = fullW - ins.left - ins.right + 'px'),
        (logo.style.height = fullH - ins.top - ins.bottom + 'px'),
        (logoImg.src = d._fullEdited),
        (logoImg.style.position = 'absolute'),
        (logoImg.style.left = -ins.left + 'px'),
        (logoImg.style.top = -ins.top + 'px'),
        (logoImg.style.width = fullW + 'px'),
        (logoImg.style.clipPath = `inset(${ins.top}px ${ins.right}px ${ins.bottom}px ${ins.left}px)`),
        Object.assign(myDrag, { type: 'crop', ins, ins0: { ...ins }, fullW, fullH, natW, natH, sc, fullCx, fullCy, th, d, stageRect }),
        myDrag.lastX !== void 0 && applyCropMove(myDrag, myDrag.lastX, myDrag.lastY));
    }),
      (h.onpointermove = (e) => {
        if (drag) {
          if (drag.type === 'crop-pending') {
            ((drag.lastX = e.clientX), (drag.lastY = e.clientY));
            return;
          }
          drag.type === 'crop' && (e.stopPropagation(), applyCropMove(drag, e.clientX, e.clientY));
        }
      }),
      (h.onpointerup = () => {
        if (drag?.type === 'crop-pending') {
          drag = null;
          return;
        }
        if (drag?.type !== 'crop') return;
        const g = drag;
        ((drag = null),
          (async () => {
            const d = g.d,
              i = g.ins,
              p = d.placement;
            let rect = {
              x: Math.round(i.left / g.sc),
              y: Math.round(i.top / g.sc),
              w: Math.round((g.fullW - i.left - i.right) / g.sc),
              h: Math.round((g.fullH - i.top - i.bottom) / g.sc),
            };
            ((rect.x = clamp(rect.x, 0, g.natW - 1)),
              (rect.y = clamp(rect.y, 0, g.natH - 1)),
              (rect.w = clamp(rect.w, 1, g.natW - rect.x)),
              (rect.h = clamp(rect.h, 1, g.natH - rect.y)),
              (d._cropRect = rect.x === 0 && rect.y === 0 && rect.w === g.natW && rect.h === g.natH ? null : rect));
            const vx = i.left + (g.fullW - i.left - i.right) / 2 - g.fullW / 2,
              vy = i.top + (g.fullH - i.top - i.bottom) / 2 - g.fullH / 2,
              stageRect = stageEl.getBoundingClientRect();
            ((p.x = ((g.fullCx + vx * Math.cos(g.th) - vy * Math.sin(g.th)) / stageRect.width) * 100),
              (p.y = ((g.fullCy + vx * Math.sin(g.th) + vy * Math.cos(g.th)) / stageRect.height) * 100),
              (p.w = Math.max(minLogoW(), g.fullW - i.left - i.right)),
              await rebuildLogoData(d),
              (logoImg.style.clipPath = ''),
              (logoImg.style.position = ''),
              (logoImg.style.left = ''),
              (logoImg.style.top = ''),
              (logo.style.width = ''),
              (logo.style.height = ''),
              updateStage(),
              autoSave());
          })());
      }));
  });
  const tintPop = $('#ldm-tint-pop'),
    tintHex = $('#ldm-tint-hex'),
    tintHint = $('#ldm-tint-hint'),
    brushEl = $('#ldm-stage-color-button'),
    colorControls = $('#ldm-color-controls'),
    threadTitle = $('#ldm-thread-title'),
    threadFeedback = $('#ldm-thread-feedback'),
    tintInput = $('#ldm-tint-input'),
    tintSwatch = $('#ldm-tint-swatch');
  let colorEditorDesign = null,
    colorEditorMode = null,
    colorEditorSide = null;
  let colorEditorCapColor = null;
let ldCapThreadPreviewSeq = 0;
function ldCapThreadSelected() {
  return [...new Set(mixOn() ? state.mix.filter(row => row.qty > 0).map(row => row.color) : [state.color])];
}
function ldCapThreadChoice(d, color = displayedColor()) {
  return window.LiftDownThreadColors.describe(d, color);
}
function ldCapThreadMode(d, nextMode) {
  if (d.mode === nextMode) return;
  if (d.mode === 'text') {
    d._textThreadByColor = d.threadByColor;
    const saved = d._fileThreadState || {};
    d.threadByColor = saved.map || {};
    d.threadSource = saved.source || null;
    d.defaultTint = saved.defaultTint === undefined ? d._tint || null : saved.defaultTint;
  } else {
    d._fileThreadState = { map: d.threadByColor || {}, source: d.threadSource || null, defaultTint: d.defaultTint === undefined ? d._tint || null : d.defaultTint };
    d.threadByColor = d._textThreadByColor || {};
    d.threadSource = null;
    d.defaultTint = null;
  }
  window.LiftDownThreadColors.clear(d);
}
function ldCapThreadResetFile(d) {
  if (d.mode === 'text') d._fileThreadState = { map: {}, source: null, defaultTint: null };
  else { d.threadByColor = {}; d.threadSource = null; d.defaultTint = null; }
  window.LiftDownThreadColors.clear(d);
}
async function ldCapThreadPreview(d, color) {
  const sequence = ++ldCapThreadPreviewSeq;
  const side = state.side;
  const mode = d.mode;
  const data = d.data;
  const choice = ldCapThreadChoice(d, color).value;
  if (choice === undefined) { logoImg.src = data || ''; return; }
  try {
    const rendered = await window.LiftDownThreadColors.render(d, color);
    if (sequence !== ldCapThreadPreviewSeq || d !== state.designs[state.side] || state.side !== side || displayedColor() !== color || d.mode !== mode || d.data !== data || ldCapThreadChoice(d, color).value !== choice) return;
    if (mode === 'text' && inlineTextEl.classList.contains('active')) return;
    logoImg.src = rendered || '';
  } catch (error) {
    if (sequence !== ldCapThreadPreviewSeq || d !== state.designs[state.side] || displayedColor() !== color) return;
    console.error('[thread-preview] failed', error);
    showError(tintPop.dataset.previewError);
  }
}
function ldCapThreadSet(value, { all = false } = {}) {
  const d = colorEditorDesign;
  const color = colorEditorCapColor;
  if (!d || d !== state.designs[state.side] || d.mode !== colorEditorMode || state.side !== colorEditorSide || color !== displayedColor()) { closeColorEditor(); return; }
  const api = window.LiftDownThreadColors;
  if (value !== null && !api.normalizeHex(value)) return;
  if (d.mode === 'text' && value === null) return;
  if (d.mode !== 'text' && !d._fullBase) {
    d._fullBase = d.threadSource || d.data;
    d._fullEdited = d.data;
    d._cropRect = null;
  }
  if (d.defaultTint === undefined) d.defaultTint = d._tint || null;
  const options = { mode: d.mode };
  d.threadByColor = all ? api.applyToSelected(d.threadByColor, ldCapThreadSelected(), value, options) : api.withOverride(d.threadByColor, color, value, options);
  _lastSavedHash = null;
  setTintUI(value);
  syncThreadControls(d);
  updateStage();
  if (d.mode === 'text') { applyInlineTextStyle(); updateTextPreview(); }
  autoSave();
  if (all) threadFeedback.textContent = tintPop.dataset.appliedAll;
  if (d.mode !== 'text' && value) {
    const base = d._fullBase;
    void loadImg(base).then(image => {
      if (colorEditorDesign === d && colorEditorCapColor === color && ldCapThreadChoice(d, color).hex === value) tintHint.hidden = hasTransparency(image);
    }).catch(() => {});
  } else tintHint.hidden = true;
}
function colorName(hex) {
    return hex?.toUpperCase() || tintPop.dataset.original;
  }
  function closeColorEditor() {
  tintPop.hidden = true;
  colorEditorDesign = null;
  colorEditorMode = null;
  colorEditorSide = null;
  colorEditorCapColor = null;
}
  function syncThreadControls(d = state.designs[state.side]) {
  const isText = d.mode === 'text';
  const available = isText || !!d.data;
  colorControls.hidden = !available;
  brushEl.hidden = !available;
  stageEl.classList.toggle('ldm-stage--has-color', available);
  if (!available) { closeColorEditor(); return; }
  const color = displayedColor();
  const hex = ldCapThreadChoice(d, color).hex;
  const swatch = $('#ldm-stage-color-swatch');
  swatch.style.background = hex || '';
  swatch.classList.toggle('ldm-thread-trigger__swatch--original', !hex);
  const placement = tintPop.dataset[state.side.toLowerCase()];
  const context = tintPop.dataset.forColor.replace('__COLOR__', color);
  brushEl.setAttribute('aria-label', `${placement} · ${context}: ${colorName(hex)}`);
  $('#ldm-thread-apply-all').hidden = ldCapThreadSelected().length < 2;
  const changed = colorEditorDesign !== d || colorEditorMode !== d.mode || colorEditorSide !== state.side || colorEditorCapColor !== color;
  colorEditorDesign = d;
  colorEditorMode = d.mode;
  colorEditorSide = state.side;
  colorEditorCapColor = color;
  $('#ldm-thread-help').hidden = isText;
  threadTitle.textContent = `${placement} · ${context}`;
  if (changed) {
    setTintUI(hex);
    tintHint.hidden = true;
  }
  tintPop.hidden = false;
}
  function hasTransparency(img) {
    try {
      const c = document.createElement('canvas'),
        s = Math.min(1, 256 / Math.max(img.naturalWidth, img.naturalHeight));
      ((c.width = Math.max(1, Math.round(img.naturalWidth * s))), (c.height = Math.max(1, Math.round(img.naturalHeight * s))));
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, c.width, c.height);
      const px = ctx.getImageData(0, 0, c.width, c.height).data;
      for (let i = 3; i < px.length; i += 4) if (px[i] < 250) return !0;
      return !1;
    } catch {
      return !0;
    }
  }
  async function applyTint(hex, d) {
    if (!(!d?.data || d.mode === 'text'))
      try {
        d._fullBase || ((d._fullBase = d.data), (d._fullEdited = d.data), (d._cropRect = null));
        const base = d._fullBase;
        if (((d._tint = hex), await rebuildLogoData(d), d._fullBase !== base || d._tint !== hex)) return;
        (d === state.designs[state.side] && d.mode !== 'text' && ((logoImg.src = d.data), syncThreadControls(d)), autoSave());
        const transparent = hasTransparency(await loadImg(base));
        colorEditorDesign === d && colorEditorMode !== 'text' && d._tint === hex && (tintHint.hidden = !hex || transparent);
      } catch (e) {
        console.error('[tint] failed:', e);
      }
  }
  function setTintUI(hex) {
    ((tintHex.value = hex || ''),
      tintHex.removeAttribute('aria-invalid'),
      (threadFeedback.textContent = ''),
      ($('#ldm-tint-reset').hidden = colorEditorMode === 'text' || !hex),
      (tintInput.value = hex || '#FFFFFF'),
      (tintSwatch.style.background = hex || ''),
      tintSwatch.classList.toggle('ldm-thread-trigger__swatch--original', !hex));
  }
  function openTintPop(trigger = null, { focus = true, scroll = true } = {}) {
  closeAllTextPopovers();
  syncThreadControls();
  if (tintPop.hidden) return;
  if (focus) threadTitle.focus({ preventScroll: true });
  if (scroll) tintPop.scrollIntoView({ block: 'nearest' });
}
  function chooseThreadColor(hex) {
  if (!window.LiftDownThreadColors.normalizeHex(hex)) {
    tintHex.setAttribute('aria-invalid', 'true');
    threadFeedback.textContent = threadFeedback.dataset.invalid;
    return;
  }
  ldCapThreadSet(hex.toUpperCase());
}
function openThreadPicker() {
  closeAllTextPopovers();
  syncThreadControls();
  if (tintPop.hidden) return;
  tintPop.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
  if (typeof tintInput.showPicker === 'function') {
    try { tintInput.showPicker(); return; } catch (_) {}
  }
  tintInput.click();
}

function applyCustomColor({ validate = false } = {}) {
  const value = tintHex.value.trim();
  if (!value && colorEditorDesign && !ldCapThreadChoice(colorEditorDesign).hex) {
    tintHex.removeAttribute('aria-invalid');
    threadFeedback.textContent = '';
    return;
  }
  const hex = value.startsWith('#') ? value : '#' + value;
  if (window.LiftDownThreadColors.normalizeHex(hex)) {
    chooseThreadColor(hex);
  } else if (validate) {
    tintHex.setAttribute('aria-invalid', 'true');
    threadFeedback.textContent = threadFeedback.dataset.invalid;
  } else {
    tintHex.removeAttribute('aria-invalid');
    threadFeedback.textContent = '';
  }
}

function installThreadPickerControls() {
  brushEl.onclick = event => {
    event.stopPropagation();
    openThreadPicker();
  };
  brushEl.onpointerdown = event => { event.stopPropagation(); event.preventDefault(); };
  tintInput.oninput = () => chooseThreadColor(tintInput.value);
  tintInput.onchange = () => chooseThreadColor(tintInput.value);
  tintHex.oninput = () => applyCustomColor();
  tintHex.onchange = () => applyCustomColor({ validate: true });
  tintHex.onblur = () => applyCustomColor({ validate: true });
  tintHex.onkeydown = event => {
    if (event.key === 'Enter') { event.preventDefault(); applyCustomColor({ validate: true }); }
  };
  tintHex.onfocus = () => tintHex.select();
  $('#ldm-tint-reset').onclick = () => ldCapThreadSet(null);
  $('#ldm-thread-apply-all').onclick = () => {
    const d = colorEditorDesign;
    if (d) ldCapThreadSet(ldCapThreadChoice(d).hex, { all: true });
  };
}
installThreadPickerControls();

logo.onpointerdown = (e) => {
      if (
        e.target.closest('.ldm-logo-resize') ||
        e.target.closest('.ldm-logo-rotate') ||
        e.target.closest('.ldm-logo-remove') ||
        e.target.closest('.ldm-logo-crop') ||
        e.target.closest('.ldm-logo-brush')
      )
        return;
      (logo.classList.add('selected'), e.preventDefault(), e.stopPropagation());
      try {
        logo.setPointerCapture(e.pointerId);
      } catch {}
      const logoRect = logo.getBoundingClientRect(),
        stageRect = stageEl.getBoundingClientRect();
      drag = {
        type: 'drag',
        sx: e.clientX,
        sy: e.clientY,
        startX: logoRect.left + logoRect.width / 2 - stageRect.left,
        startY: logoRect.top + logoRect.height / 2 - stageRect.top,
      };
    };

          function handleDragMove(e) {
    if (!drag || drag.type !== 'drag') return;
    const stageRect = stageEl.getBoundingClientRect();
    let newX = clamp(drag.startX + e.clientX - drag.sx, 30, stageRect.width - 30),
      newY = clamp(drag.startY + e.clientY - drag.sy, 30, stageRect.height - 30);
    ((logo.style.left = (newX / stageRect.width) * 100 + '%'), (logo.style.top = (newY / stageRect.height) * 100 + '%'));
  }
  function handleDragUp(e) {
    drag?.type === 'drag' && (savePlacement(), (drag = null));
  }
  ((logo.onpointermove = handleDragMove),
    (logo.onpointerup = handleDragUp),
    (logo.ondblclick = () => {
      const d = state.designs[state.side];
      d.mode === 'text' &&
        d.textConfig.text.trim() &&
        (logo.classList.remove('active', 'selected'),
        (logoImg.src = ''),
        stageBtns.classList.add('hidden'),
        inlineTextEl.classList.add('active'),
        (inlineTextInput.value = d.textConfig.text),
        applyInlineTextStyle(),
        applyInlineTextPlacement(d.placement),
        setTimeout(() => inlineTextInput.focus(), 50));
    }),
    document.addEventListener('pointermove', handleDragMove),
    document.addEventListener('pointerup', handleDragUp),
    ($('#ldm-logo-remove').onclick = (e) => {
      (e.stopPropagation(), removeDesign());
    }),
    (fileRemoveEl.onclick = () => removeDesign()));
  function getBase(qty) {
    for (let i = TIERS.length - 1; i >= 0; i--) if (qty >= TIERS[i].q) return TIERS[i].price;
    return TIERS[0].price;
  }
  function getSavings(qty) {
    const max = TIERS[0].price,
      cur = getBase(qty);
    return cur >= max ? 0 : Math.round((1 - cur / max) * 100);
  }
  function countDesigns() {
    return Object.values(state.designs).filter((d) => d.data).length;
  }
  function getDesignSides() {
    return ['Front', 'Back', 'Side'].filter((s) => state.designs[s].data);
  }
  function updatePricing() {
    const qty = state.qty,
      base = getBase(qty),
      sides = getDesignSides(),
      locs = sides.length,
      embLocs = Math.max(1, locs),
      emb = embLocs * EMB_PRICE,
      per = base + emb,
      subtotal = per * qty,
      savings = getSavings(qty);
    ((pricePerEl.textContent = `${formatMoney(per)}/hat`), (saveEl.style.display = 'none'), (totalEl.textContent = formatMoney(subtotal)));
    const incLabel = sides.length ? `incl. ${sides.join(' + ')} embroidery` : 'incl. Front embroidery',
      mixCols = state.mix ? state.mix.length : 0;
    document.querySelectorAll('.ldm-qty-tier').forEach((tier) => {
      const tierQty = parseInt(tier.dataset.qty),
        tierPer = getBase(tierQty) + embLocs * EMB_PRICE,
        tierTotal = tierPer * tierQty,
        tierSavings = getSavings(tierQty);
      ((tier.querySelector('.ldm-tier-price').textContent = `${formatMoney(tierPer)}/hat`), (tier.querySelector('.ldm-tier-total').textContent = formatMoney(tierTotal)));
      const incSpan = tier.querySelector('.ldm-tier-includes');
      (incSpan && (incSpan.textContent = incLabel),
        tier.classList.toggle('active', tierQty === qty),
        tier.setAttribute('aria-pressed', String(tierQty === qty)),
        tier.classList.toggle('ldm-tier-locked', mixCols > 0 && tierQty < mixCols * 25));
    });
    const customIncEl = $('#ldm-custom-includes');
    customIncEl && (customIncEl.textContent = incLabel);
    const customRow = $('#ldm-qty-custom');
    customRow && customRow.classList.toggle('active', !TIERS.some((t) => t.q === qty));
    let breakdownHTML = '';
    ((breakdownHTML += `<div class="ldm-tooltip-row">
              <span>Base price:</span>
              <span>${qty} x ${formatMoney(base)} = ${formatMoney(base * qty)}</span>
            </div>`),
      (sides.length ? sides : ['Front']).forEach((side) => {
        breakdownHTML += `<div class="ldm-tooltip-row">
                <span>${side} embroidery:</span>
                <span>${qty} x ${formatMoney(EMB_PRICE)} = ${formatMoney(EMB_PRICE * qty)}</span>
              </div>`;
      }),
      ($('#ldm-bd-rows').innerHTML = breakdownHTML),
      ($('#ldm-bd-total').textContent = formatMoney(subtotal)));
    const embNoteEl = $('#ldm-emb-note');
    embNoteEl &&
      (locs === 0
        ? (embNoteEl.innerHTML = 'Price includes <strong>1 embroidery location</strong>. Add your logo or text above.')
        : locs === 1
          ? (embNoteEl.innerHTML = `Price includes <strong>${sides[0]} embroidery</strong>.`)
          : (embNoteEl.innerHTML = `Price includes <strong>${locs} embroidery locations</strong> (${sides.join(', ')}) at ${formatMoney(EMB_PRICE)}/hat each.`));
  }
  function renderTierRows() {
    const container = $('#ldm-qty-tiers');
    ((container.innerHTML = TIERS.map((t) => {
      const per = t.price + EMB_PRICE;
      return `
              <button type="button" class="ldm-qty-tier${t.q === state.qty ? ' active' : ''}" data-qty="${t.q}" aria-pressed="${String(t.q === state.qty)}">
                <span class="ldm-tier-qty">${t.q.toLocaleString()} hats</span>
                <span class="ldm-tier-includes"></span>
                <span class="ldm-tier-price">${formatMoney(per)}/hat</span>
                <span class="ldm-tier-total">${formatMoney(per * t.q)}</span>
              </button>
            `;
    }).join('')),
      container.querySelectorAll('.ldm-qty-tier').forEach((tier) => {
        tier.onclick = () => {
          const target = parseInt(tier.dataset.qty);
          if (mixOn()) {
            if (!applyMixTarget(target)) {
              const n = state.mix.length;
              showMixQtyNote(`A ${n}-color mix has a ${n * 25} hat minimum (25 per color). Remove a color to order fewer.`);
            }
            return;
          }
          ((state.qty = target), (qtyEl.value = state.qty), updatePricing());
        };
      }));
  }
  renderTierRows();
  const underMinLink = $('#ldm-under-min-link');
  underMinLink &&
    underMinLink.addEventListener('click', () => {
      try {
        trackEvent('UnderMinimumClicked', { qty: state.qty });
      } catch {}
    });
  const underMinEl = $('#ldm-under-min'),
    underMinLead = $('#ldm-under-min-lead');
  let _underMinTracked = !1;
  function flagUnderMin(raw) {
    if (!underMinEl) return;
    const wants = parseInt(raw, 10),
      under = Number.isFinite(wants) && wants > 0 && wants < 25;
    (underMinEl.classList.toggle('prompted', under),
      underMinLead && (underMinLead.textContent = under ? 'Our minimum here is 25 caps. Only need ' + wants + '?' : 'Need fewer than 25?'),
      under && !_underMinTracked && ((_underMinTracked = !0), trackEvent('UnderMinimumPrompted', { requested: wants })));
  }
  ((qtyEl.oninput = () => {
    mixOn() || (flagUnderMin(qtyEl.value), (state.qty = Math.min(99999, Math.max(25, parseInt(qtyEl.value) || 25))), updatePricing());
  }),
    (qtyEl.onblur = () => {
      qtyEl.value = state.qty;
    }));
  const mixToggleEl = $('#ldm-mix-toggle'),
    mixPanelEl = $('#ldm-mix'),
    mixRowsEl = $('#ldm-mix-rows'),
    mixTotalQtyEl = $('#ldm-mix-total-qty'),
    mixAddEl = $('#ldm-mix-add'),
    mixAddLabelEl = $('#ldm-mix-add-label'),
    mixPreviewNameEl = $('#ldm-mix-preview-name'),
    mixPreviewNoteEl = $('#ldm-mix-preview-note'),
    mixCountEl = $('#ldm-mix-count'),
    mixStatusEl = $('#ldm-mix-status'),
    sizesWrapEl = $('#ldm-sizes-wrap'),
    sizesToggleEl = $('#ldm-sizes-toggle'),
    sizeSEl = $('#ldm-size-s'),
    sizeREl = $('#ldm-size-r'),
    sizeXlEl = $('#ldm-size-xl');
  function mixOn() {
    return Array.isArray(state.mix) && state.mix.length > 0;
  }
  function mixTotal() {
    return state.mix.reduce((a, r) => a + (r.qty || 0), 0);
  }
  function mixAdd(color) {
    return !mixOn() || !COLORS.includes(color) || state.mix.some((r) => r.color === color) ? !1 : (state.mix.push({ color, qty: 25, s: 0, xl: 0 }), !0);
  }
  function addPreviewToMix() {
    const color = displayedColor();
    if (!mixAdd(color)) return;
    ((state.color = color),
      (mixPreviewColor = null),
      renderSwatches(),
      renderMix(),
      updateStage(),
      mixStatusEl && (mixStatusEl.textContent = `${color} added. 25 caps. ${mixTotal().toLocaleString()} caps in your order.`));
    const quantity = mixRowsEl && mixRowsEl.querySelector('.ldm-mix-row-wrap:last-child .ldm-mix-qty');
    quantity && quantity.focus({ preventScroll: !0 });
  }
  function clampRowSizes(r) {
    ((r.s = Math.max(0, r.s | 0)), (r.xl = Math.max(0, r.xl | 0)), r.s + r.xl > r.qty && ((r.xl = Math.max(0, r.qty - r.s)), (r.s = Math.min(r.s, r.qty))));
  }
  function rowSizesSuffix(r) {
    return !r.s && !r.xl ? ` (R ${r.qty})` : ` (S ${r.s} / R ${Math.max(0, r.qty - r.s - r.xl)} / XL ${r.xl})`;
  }
  function hasAnySizes() {
    return mixOn() ? state.mix.some((r) => r.s || r.xl) : !!(state.sizes.s || state.sizes.xl);
  }
  function sizesLabel() {
    if (mixOn()) {
      const t = state.mix.reduce((a, r) => ({ s: a.s + (r.s | 0), xl: a.xl + (r.xl | 0) }), { s: 0, xl: 0 });
      return !t.s && !t.xl ? `R ${state.qty}` : `S ${t.s} / R ${Math.max(0, state.qty - t.s - t.xl)} / XL ${t.xl}`;
    }
    return !state.sizes.s && !state.sizes.xl ? `R ${state.qty}` : `S ${state.sizes.s} / R ${Math.max(0, state.qty - state.sizes.s - state.sizes.xl)} / XL ${state.sizes.xl}`;
  }
  function orderColorLabel() {
    return mixOn() ? state.mix.map((r) => `${r.color} ${r.qty}`).join(', ') : state.color;
  }
  function orderMixDetail() {
    return state.mix.map((r) => `- ${r.color}: ${r.qty}${rowSizesSuffix(r)}`).join(`
`);
  }
  function syncFromMix() {
    if (threadNoteEl) {
      const colors = new Set((state.mix || []).filter((row) => row.qty > 0).map((row) => row.color));
      threadNoteEl.hidden = colors.size < 2;
    }
    (mixOn() ? ((state.qty = Math.max(25, mixTotal())), (qtyEl.value = state.qty), (qtyEl.disabled = !0)) : (qtyEl.disabled = !1),
      sizesWrapEl && (sizesWrapEl.style.display = mixOn() ? 'none' : ''),
      updatePricing());
  }
  function renderMix() {
    if (!mixPanelEl) return;
    if (((mixPanelEl.style.display = mixOn() ? '' : 'none'), mixToggleEl)) {
      const mixLbl = document.getElementById('ldm-mix-toggle-label');
      mixLbl && (mixLbl.textContent = mixOn() ? 'Order a single color instead' : 'Add multiple colors to your order');
      const mixBadge = document.querySelector('#ldm-mix-toggle .ldm-new-badge');
      (mixBadge && (mixBadge.style.display = mixOn() ? 'none' : ''), mixToggleEl.setAttribute('aria-expanded', String(mixOn())));
    }
    if (!mixOn()) {
      syncFromMix();
      return;
    }
    const preview = displayedColor(),
      included = state.mix.find((row) => row.color === preview);
    (mixPreviewNameEl && (mixPreviewNameEl.textContent = preview),
      mixPreviewNoteEl && (mixPreviewNoteEl.textContent = included ? `${included.qty.toLocaleString()} caps in your order` : 'Adds 25 caps \xB7 adjust below'),
      mixAddEl && ((mixAddEl.disabled = !!included), mixAddEl.setAttribute('aria-label', included ? `${preview} is in your order` : `Add ${preview} to mix`)),
      mixAddLabelEl && (mixAddLabelEl.textContent = included ? 'In your order' : 'Add to mix'),
      mixCountEl && (mixCountEl.textContent = `${state.mix.length} ${state.mix.length === 1 ? 'color' : 'colors'}`),
      (mixRowsEl.innerHTML = ''),
      state.mix.forEach((row, i) => {
        clampRowSizes(row);
        const wrap = document.createElement('div');
        ((wrap.className = 'ldm-mix-row-wrap' + (row._sizesOpen ? ' sizes-open' : '')), (wrap.dataset.idx = i));
        const reg = Math.max(0, row.qty - row.s - row.xl);
        ((wrap.innerHTML = `
                <div class="ldm-mix-row${row.color === preview ? ' preview' : ''}">
                  <button type="button" class="ldm-mix-swatch" data-act="preview" title="Preview ${esc(row.color)}"><img src="${swatchImage(row.color)}" alt=""></button>
                  <button type="button" class="ldm-mix-name" data-act="preview" aria-label="Preview ${esc(row.color)} cap">${esc(row.color)}</button>
                  <label class="ldm-mix-qty-field"><span>Qty</span><input type="number" class="ldm-mix-qty" data-act="qty" min="25" max="99999" value="${row.qty}" inputmode="numeric" aria-label="Quantity for ${esc(row.color)}"></label>
                  <button type="button" class="ldm-mix-sizes-btn" data-act="sizes" aria-expanded="${String(!!row._sizesOpen)}">Sizes</button>
                  <button type="button" class="ldm-mix-remove" data-act="remove" aria-label="Remove ${esc(row.color)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v5M14 11v5"/></svg></button>
                </div>
                <div class="ldm-mix-sizes">
                  <div class="ldm-size-field"><label>Small</label><input type="number" data-act="s" min="0" value="${row.s}" inputmode="numeric" aria-label="Small caps for ${esc(row.color)}"></div>
                  <div class="ldm-size-field"><label>Regular</label><input type="number" readonly tabindex="-1" value="${reg}"></div>
                  <div class="ldm-size-field"><label>XL</label><input type="number" data-act="xl" min="0" value="${row.xl}" inputmode="numeric" aria-label="XL caps for ${esc(row.color)}"></div>
                  <div class="ldm-size-field ldm-size-guide-field"><label aria-hidden="true">&nbsp;</label><a class="ldm-size-guide" href="https://liftdown.com/pages/size-guide" target="_blank" rel="noopener" aria-label="Size guide, opens in a new tab">Size guide <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"/><path d="M7 7h10v10"/></svg></a></div>
                </div>`),
          mixRowsEl.appendChild(wrap));
      }),
      mixTotalQtyEl && (mixTotalQtyEl.textContent = `${mixTotal().toLocaleString()} hats`),
      syncFromMix());
  }
  function applyMixTarget(target) {
    if (!mixOn()) return !1;
    const rows = state.mix,
      n = rows.length,
      minTotal = n * 25;
    if (((target = Math.max(25, Math.min(99999, parseInt(target, 10) || 0))), target < minTotal)) return !1;
    const cur = mixTotal() || minTotal,
      alloc = rows.map((r) => Math.max(25, Math.round(((r.qty || 25) / cur) * target)));
    let diff = target - alloc.reduce((a, b) => a + b, 0);
    for (let i = 0, guard = 0; diff !== 0 && guard < 2e4; i++, guard++) {
      const k = i % n;
      diff > 0 ? (alloc[k]++, diff--) : alloc[k] > 25 && (alloc[k]--, diff++);
    }
    return (
      rows.forEach((r, k) => {
        ((r.qty = alloc[k]), clampRowSizes(r));
      }),
      renderMix(),
      !0
    );
  }
  function showMixQtyNote(msg) {
    const el = $('#ldm-qty-mix-note');
    el && ((el.textContent = msg), el.classList.add('show'), clearTimeout(el._noteTimer), (el._noteTimer = setTimeout(() => el.classList.remove('show'), 6e3)));
  }
  function enterMix() {
    ((mixPreviewColor = null),
      (state.mix = [{ color: state.color, qty: state.qty, s: state.sizes.s | 0, xl: state.sizes.xl | 0 }]),
      renderSwatches(),
      renderMix(),
      trackEvent('ColorMixEnabled', { color: state.color }));
  }
  function exitMix() {
    const color = mixPreviewColor || state.color;
    if (mixOn()) {
      ((state.qty = Math.max(25, mixTotal())), (qtyEl.value = state.qty));
      const t = state.mix.reduce((a, r) => ({ s: a.s + (r.s | 0), xl: a.xl + (r.xl | 0) }), { s: 0, xl: 0 });
      state.sizes = t;
    }
    ((state.mix = null), (state.color = color), (mixPreviewColor = null), renderSwatches(), renderMix(), updateStage(), renderGlobalSizes());
  }
  (mixToggleEl &&
    (mixToggleEl.onclick = () => {
      mixOn() ? exitMix() : enterMix();
    }),
    mixAddEl && (mixAddEl.onclick = addPreviewToMix),
    mixRowsEl &&
      (mixRowsEl.addEventListener('click', (e) => {
        const actEl = e.target.closest('[data-act]'),
          wrap = e.target.closest('.ldm-mix-row-wrap');
        if (!actEl || !wrap) return;
        const row = state.mix && state.mix[+wrap.dataset.idx];
        if (!row) return;
        const act = actEl.dataset.act;
        if (
          (act === 'preview'
            ? selectColor(row.color)
            : act === 'sizes'
              ? ((row._sizesOpen = !row._sizesOpen), renderMix())
              : act === 'remove' &&
                (state.mix.length === 1
                  ? (exitMix(), mixStatusEl && (mixStatusEl.textContent = 'Switched to a single-color order.'))
                  : (state.mix.splice(+wrap.dataset.idx, 1),
                    state.mix.some((item) => item.color === state.color) || (state.color = state.mix[0].color),
                    renderSwatches(),
                    renderMix(),
                    updateStage(),
                    mixStatusEl && (mixStatusEl.textContent = `${row.color} removed from your mix.`))),
          act === 'preview' || act === 'sizes' || act === 'remove')
        ) {
          const index = mixOn() ? Math.min(+wrap.dataset.idx, state.mix.length - 1) : -1,
            nextFocus = index < 0 ? mixToggleEl : mixRowsEl.querySelector(`.ldm-mix-row-wrap[data-idx="${index}"] [data-act="${act}"]`);
          nextFocus && nextFocus.focus({ preventScroll: !0 });
        }
      }),
      mixRowsEl.addEventListener('change', (e) => {
        const wrap = e.target.closest('.ldm-mix-row-wrap');
        if (!wrap || !e.target.dataset.act) return;
        const row = state.mix && state.mix[+wrap.dataset.idx];
        if (!row) return;
        const act = e.target.dataset.act;
        (act === 'qty'
          ? (row.qty = Math.min(99999, Math.max(25, parseInt(e.target.value) || 25)))
          : act === 's'
            ? (row.s = Math.max(0, parseInt(e.target.value) || 0))
            : act === 'xl' && (row.xl = Math.max(0, parseInt(e.target.value) || 0)),
          clampRowSizes(row));
        const reg = Math.max(0, row.qty - row.s - row.xl),
          qEl = wrap.querySelector('[data-act="qty"]'),
          sEl2 = wrap.querySelector('[data-act="s"]'),
          xlEl2 = wrap.querySelector('[data-act="xl"]'),
          regEl2 = wrap.querySelector('input[readonly]');
        (qEl && (qEl.value = row.qty),
          sEl2 && (sEl2.value = row.s),
          xlEl2 && (xlEl2.value = row.xl),
          regEl2 && (regEl2.value = reg),
          mixTotalQtyEl && (mixTotalQtyEl.textContent = `${mixTotal().toLocaleString()} hats`),
          mixPreviewNoteEl && row.color === displayedColor() && (mixPreviewNoteEl.textContent = `${row.qty.toLocaleString()} caps in your order`),
          syncFromMix());
      })));
  function clampGlobalSizes() {
    const z = state.sizes;
    ((z.s = Math.max(0, z.s | 0)), (z.xl = Math.max(0, z.xl | 0)), z.s + z.xl > state.qty && ((z.xl = Math.max(0, state.qty - z.s)), (z.s = Math.min(z.s, state.qty))));
  }
  function renderGlobalSizes() {
    sizeSEl && (clampGlobalSizes(), (sizeSEl.value = state.sizes.s), (sizeXlEl.value = state.sizes.xl), (sizeREl.value = Math.max(0, state.qty - state.sizes.s - state.sizes.xl)));
  }
  function openGlobalSizes() {
    if (!sizesWrapEl || sizesWrapEl.classList.contains('expanded')) return;
    (sizesWrapEl.classList.add('expanded'), sizesToggleEl && sizesToggleEl.setAttribute('aria-expanded', 'true'));
    const lbl = $('#ldm-sizes-toggle-label');
    lbl && (lbl.textContent = 'Choose sizes');
  }
  (sizesToggleEl &&
    (sizesToggleEl.onclick = () => {
      const expanding = !sizesWrapEl.classList.contains('expanded');
      (sizesWrapEl.classList.toggle('expanded', expanding), sizesToggleEl.setAttribute('aria-expanded', String(expanding)));
      const lbl = $('#ldm-sizes-toggle-label');
      (lbl && (lbl.textContent = 'Choose sizes'), expanding && renderGlobalSizes());
    }),
    sizeSEl &&
      (sizeSEl.onchange = () => {
        ((state.sizes.s = Math.max(0, parseInt(sizeSEl.value) || 0)), renderGlobalSizes(), updatePricing());
      }),
    sizeXlEl &&
      (sizeXlEl.onchange = () => {
        ((state.sizes.xl = Math.max(0, parseInt(sizeXlEl.value) || 0)), renderGlobalSizes(), updatePricing());
      }));
  const _mixPrevUpdatePricing = updatePricing;
  ((updatePricing = function () {
    (_mixPrevUpdatePricing(), renderGlobalSizes(), updateLeadTime());
  }),
    (function () {
      const panel = $('#ldm-lead-inline'),
        openBtn = $('#ldm-lead-open');
      if (!panel || !openBtn) return;
      const ATTIO_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/7650002/upe8j3n/',
        UPLOAD_URL = EMAIL_URL.replace('send-wholesale-email', 'upload-lead-assets'),
        BUSINESS_EMAIL = 'wholesale@liftdown.com',
        LEAD_MIME = {
          pdf: 'application/pdf',
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          png: 'image/png',
          webp: 'image/webp',
          svg: 'image/svg+xml',
          ai: 'application/illustrator',
          eps: 'application/postscript',
        },
        LEAD_MAX_FILES = 6,
        LEAD_MAX_FILE_BYTES = 4 * 1024 * 1024,
        LEAD_MAX_TOTAL_BYTES = 4 * 1024 * 1024,
        form = $('#ldm-lead-form'),
        successEl = $('#ldm-lead-success'),
        errorEl2 = $('#ldm-lead-error'),
        submitBtn = $('#ldm-lead-submit'),
        noteEl = $('#ldm-lead-note'),
        includeEl = $('#ldm-lead-include'),
        dropzone = $('#ldm-lead-dropzone'),
        fileInput = $('#ldm-lead-files'),
        fileList = $('#ldm-lead-file-list');
      let leadFiles = [],
        modalOpenedAt = 0,
        leadFired = !1;
      function leadShowError(msg) {
        ((errorEl2.textContent = msg), errorEl2.classList.add('show'), errorEl2.scrollIntoView({ behavior: 'smooth', block: 'center' }));
      }
      function leadHideError() {
        errorEl2.classList.remove('show');
      }
      function qtyRange(q) {
        return q >= 1e3 ? '1,000+' : q >= 500 ? '500-1,000' : q >= 250 ? '250-500' : q >= 100 ? '100-250' : q >= 50 ? '50-100' : '25-49';
      }
      function openLead() {
        (modalOpenedAt || (modalOpenedAt = Date.now()), form.classList.remove('hidden'), successEl.classList.remove('show'), leadHideError());
        const sides = getDesignSides();
        noteEl.style.display = '';
        const contextEl = $('#ldm-help-context');
        if (contextEl) contextEl.textContent = orderColorLabel() + ' · ' + state.qty + ' caps · ' + sizesLabel() + (sides.length ? ' · ' + sides.join(' + ') + ' design' : '');
        const knownEmail = (($('#ldm-order-email') || {}).value || ($('#ldm-save-email') || {}).value || '').trim(),
          emailField = $('#ldm-lead-email');
        knownEmail && !emailField.value && (emailField.value = knownEmail);
        const qtySel = $('#ldm-lead-quantity');
        if (state.qty < 50 && !qtySel.querySelector('option[value="25-49"]')) qtySel.add(new Option('25–49', '25-49'));
        ((qtySel.value = qtyRange(state.qty)),
          (panel.hidden = !1),
          openBtn.setAttribute('aria-expanded', 'true'),
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' }),
          window.matchMedia('(pointer: coarse)').matches || setTimeout(() => $('#ldm-lead-name').focus({ preventScroll: !0 }), 350),
          trackEvent('LeadFormOpened', { has_design: sides.length > 0 }));
      }
      function closeLead() {
        ((panel.hidden = !0), openBtn.setAttribute('aria-expanded', 'false'));
      }
      $('#ldm-quick-help')?.addEventListener('click', openLead);
      const heroHelp = $('#ld-hero-team');
      if (heroHelp) {
        heroHelp.href = '#ldm-lead-inline';
        heroHelp.textContent = 'Get help with your order';
        heroHelp.addEventListener('click', (e) => {
          e.preventDefault();
          openLead();
        });
      }
      (openBtn.addEventListener('click', (e) => {
        (e.preventDefault(), panel.hidden ? openLead() : closeLead());
      }),
        $('#ldm-lead-close').addEventListener('click', closeLead));
      function leadTotalBytes() {
        return leadFiles.reduce((a, f) => a + f.size, 0);
      }
      function fmtSize(b) {
        return b < 1024 * 1024 ? Math.round(b / 1024) + ' KB' : (b / 1024 / 1024).toFixed(1) + ' MB';
      }
      function renderLeadFiles() {
        ((fileList.innerHTML = ''),
          leadFiles.forEach((f, i) => {
            const li = document.createElement('li');
            ((li.className = 'ldm-lead-file-item'),
              (li.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/></svg><span class="ldm-lead-file-name">${esc(f.name)}</span><span class="ldm-lead-file-size">${fmtSize(f.size)}</span><button type="button" class="ldm-lead-file-remove" data-i="${i}" aria-label="Remove ${esc(f.name)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>`),
              fileList.appendChild(li));
          }));
      }
      fileList.addEventListener('click', (e) => {
        const btn = e.target.closest('.ldm-lead-file-remove');
        btn && (leadFiles.splice(+btn.dataset.i, 1), renderLeadFiles());
      });
      function addLeadFiles(list) {
        leadHideError();
        for (const file of list) {
          const ext = (file.name.split('.').pop() || '').toLowerCase();
          if (!LEAD_MIME[ext]) {
            leadShowError(`"${file.name}" isn't a supported type. Use PDF, JPG, PNG, SVG, AI, or EPS.`);
            continue;
          }
          if (file.size > LEAD_MAX_FILE_BYTES) {
            leadShowError(`"${file.name}" is over the ${fmtSize(LEAD_MAX_FILE_BYTES)} per-file limit. Email it to ${BUSINESS_EMAIL}.`);
            continue;
          }
          if (!leadFiles.some((f) => f.name === file.name && f.size === file.size)) {
            if (leadFiles.length >= LEAD_MAX_FILES) {
              leadShowError(`You can attach up to ${LEAD_MAX_FILES} files.`);
              break;
            }
            if (leadTotalBytes() + file.size > LEAD_MAX_TOTAL_BYTES) {
              leadShowError('Attachments exceed the 4.0 MB total limit.');
              break;
            }
            leadFiles.push(file);
          }
        }
        renderLeadFiles();
      }
      (dropzone.addEventListener('click', () => fileInput.click()),
        dropzone.addEventListener('keydown', (e) => {
          (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), fileInput.click());
        }),
        ['dragenter', 'dragover'].forEach((ev) =>
          dropzone.addEventListener(ev, (e) => {
            (e.preventDefault(), dropzone.classList.add('dragover'));
          }),
        ),
        ['dragleave', 'drop'].forEach((ev) =>
          dropzone.addEventListener(ev, (e) => {
            (e.preventDefault(), dropzone.classList.remove('dragover'));
          }),
        ),
        dropzone.addEventListener('drop', (e) => addLeadFiles(e.dataTransfer.files)),
        fileInput.addEventListener('change', () => {
          (addLeadFiles(fileInput.files), (fileInput.value = ''));
        }));
      function readFileAsAttachment(file) {
        return new Promise((resolve, reject) => {
          const fr = new FileReader();
          ((fr.onerror = reject),
            (fr.onload = () => {
              const ext = (file.name.split('.').pop() || '').toLowerCase();
              resolve({ filename: file.name, content: String(fr.result).split(',')[1] || '', contentType: LEAD_MIME[ext] || 'application/octet-stream' });
            }),
            fr.readAsDataURL(file));
        });
      }
      async function uploadLeadAssets(fileObjs) {
        try {
          const payload = (await ldRunPreparation(async (ldCheckPreparation) => { const value = await Promise.all(fileObjs.map((f) => readFileAsAttachment(f).catch(() => null))); ldCheckPreparation(); return value; })).filter(Boolean);
          if (!payload.length) return [];
          const { resp, data } = await ldFetchWithDeadline(UPLOAD_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ files: payload }) }, LD_INQUIRY_UPLOAD_TIMEOUT_MS, 'success-json');
          if (!resp.ok) return [];
          
          return Array.isArray(data.files) ? data.files : [];
        } catch {
          return [];
        }
      }
      function leadIsSpam(txt) {
        return String(txt || '')
          .split(/\s+/)
          .some((w) => {
            if (w.length < 14) return !1;
            let t = 0;
            for (let i = 1; i < w.length; i++) /[a-z]/.test(w[i - 1]) && /[A-Z]/.test(w[i]) && t++;
            return t >= 4;
          });
      }
      function fakeSuccess() {
        (form.classList.add('hidden'), successEl.classList.add('show'));
      }
      function sendToAttio(lead, design) {
        if (!ATTIO_WEBHOOK_URL) return;
        const nameParts = (lead.fullname || '').trim().split(/\s+/),
          params = new URLSearchParams();
        (params.append('name', lead.fullname),
          params.append('first_name', nameParts.shift() || ''),
          params.append('last_name', nameParts.join(' ')),
          params.append('email', lead.email),
          params.append('company', lead.company),
          params.append('quantity', lead.quantity),
          params.append('message', lead.message || ''),
          params.append('source', 'Custom Cap Configurator'),
          params.append('page', window.location.pathname),
          params.append('submitted_at', new Date().toISOString()),
          params.append('page_url', window.location.href),
          params.append('attachment_count', String(leadFiles.length)),
          params.append('attachment_names', leadFiles.map((f) => f.name).join(', ')),
          design && (params.append('design_id', design.id || ''), params.append('design_url', design.url || ''), params.append('design_summary', design.summary || '')),
          fetch(ATTIO_WEBHOOK_URL, { method: 'POST', body: params }).catch(() => {}));
      }
      form.addEventListener('submit', async (e) => {
        if ((e.preventDefault(), leadHideError(), $('#ldm-lead-website').value || Date.now() - modalOpenedAt < 3e3)) {
          fakeSuccess();
          return;
        }
        const data = {
          fullname: $('#ldm-lead-name').value.trim(),
          email: $('#ldm-lead-email').value.trim(),
          company: $('#ldm-lead-company').value.trim(),
          quantity: $('#ldm-lead-quantity').value,
          message: $('#ldm-lead-message').value.trim(),
        };
        if (!data.fullname) {
          leadShowError('Please enter your name.');
          return;
        }
        if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
          leadShowError('Please enter a valid email address.');
          return;
        }
        if (!data.company) {
          leadShowError('Please enter your company name.');
          return;
        }
        if (!data.quantity) {
          leadShowError('Please select a quantity range.');
          return;
        }
        if (leadIsSpam(data.fullname + ' ' + data.company + ' ' + data.message)) {
          fakeSuccess();
          return;
        }
        if (includeEl.checked)
          data.message +=
            (data.message ? '\n\n' : '') +
            'Current cap selections: ' +
            orderColorLabel() +
            ' | ' +
            state.qty +
            ' caps | ' +
            sizesLabel() +
            (specialRequestsEl && specialRequestsEl.value.trim() ? ' | Special requests: ' + specialRequestsEl.value.trim() : '');
        (submitBtn.classList.add('loading'), (submitBtn.disabled = !0));
        try {
          let design = null;
          const sides = getDesignSides();
          if (sides.length && includeEl.checked)
            try {
              const saved = await saveDesignToCloud(data.email.toLowerCase(), null);
              design = {
                id: saved.id,
                url: saved.url,
                summary: `${orderColorLabel()} | ${state.qty} caps (${sizesLabel()}) | ${sides.join(' + ')} | ${formatMoney(getBase(state.qty) + Math.max(1, sides.length) * EMB_PRICE)}/hat`,
              };
            } catch (err) {
              throw new Error('Your design could not be shared. Please try again, or uncheck the design-sharing option and ask us for help.');
            }
          const metaEventId = (crypto.randomUUID && crypto.randomUUID()) || genEventId('lead');
          if ((sendToAttio(data, design), !leadFired && typeof fbq == 'function')) {
            leadFired = !0;
            try {
              fbq('track', 'Lead', { content_name: 'Design Inquiry', content_category: 'B2B' }, { eventID: metaEventId });
            } catch {}
          }
          const uploaded = leadFiles.length ? await uploadLeadAssets(leadFiles) : [],
            firstName = data.fullname.trim().split(/\s+/)[0] || '',
            businessEmailHtml = window.LiftDownConfiguratorEmails.internalInquiry({
              name: data.fullname,
              email: data.email,
              company: data.company,
              quantityRange: data.quantity,
              configuredQuantity: `${state.qty} caps (${sizesLabel()})`,
              message: data.message,
              designURL: design?.url,
              reference: design?.id,
              designSummary: design?.summary,
              artwork: uploaded,
              failedArtwork: leadFiles.map((file) => file.name),
              timestamp: new Date().toLocaleString(),
              source: window.location.pathname,
            });
          if (
            !(
              await ldFetchWithDeadline(EMAIL_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  to: BUSINESS_EMAIL,
                  replyTo: data.email,
                  subject: 'Design Inquiry - ' + data.company + ' (' + data.quantity + ')',
                  html: businessEmailHtml,
                  attachments: [],
                  _hp: $('#ldm-lead-website').value,
                  _loadedAt: modalOpenedAt,
                  meta: {
                    event_id: metaEventId,
                    event_source_url: window.location.href,
                    fbp: getFbp(),
                    fbc: getFbc(),
                    email: data.email,
                    first_name: firstName,
                    last_name: data.fullname.trim().split(/\s+/).slice(1).join(' '),
                  },
                }),
              }, LD_INQUIRY_REQUEST_TIMEOUT_MS, 'response').then(({ resp }) => resp)
            ).ok
          )
            throw new Error('Failed to submit');
          const customerEmailHtml = window.LiftDownConfiguratorEmails.inquiry({ firstName, designURL: design?.url, reference: design?.id });
          if (
            (fetch(EMAIL_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                to: data.email,
                replyTo: BUSINESS_EMAIL,
                subject: 'We received your inquiry - Lift Down',
                html: customerEmailHtml,
                attachments: [],
                _hp: $('#ldm-lead-website').value,
                _loadedAt: modalOpenedAt,
              }),
            }).catch(() => {}),
            typeof gtag == 'function')
          )
            try {
              gtag('event', 'conversion', { send_to: 'AW-726239329/cw38CM2gk98bEOGQptoC', value: 50, currency: 'USD' });
            } catch {}
          (form.classList.add('hidden'), successEl.classList.add('show'));
        } catch (err) {
          (console.error('[lead] submit failed:', err),
            leadShowError(
              err.message === 'Your design could not be shared. Please try again, or uncheck the design-sharing option and ask us for help.'
                ? err.message
                : 'Something went wrong. Please try again or email us directly.',
            ));
        } finally {
          (submitBtn.classList.remove('loading'), (submitBtn.disabled = !1));
        }
      });
    })(),
    document.addEventListener('keydown', (e) => {
      e.key === 'Escape' && closeColorPreview();
    }));
  const colorPreviewEl = $('#ldm-color-preview'),
    colorPreviewImg = $('#ldm-color-preview-img'),
    colorPreviewLoading = $('#ldm-color-preview-loading'),
    cpLabelEl = $('#ldm-cp-label'),
    cpPrevBtn = $('#ldm-cp-prev'),
    cpNextBtn = $('#ldm-cp-next');
  let _colorPreviewToken = 0,
    _previewState = { color: '', sides: [], idx: 0 };
  async function openColorPreview(color, triggerEl) {
    if (!colorPreviewEl || !color) return;
    if ((colorPreviewEl.parentNode !== document.body && document.body.appendChild(colorPreviewEl), triggerEl)) {
      const rect = triggerEl.getBoundingClientRect(),
        sx = window.pageXOffset || 0,
        sy = window.pageYOffset || 0,
        vw = document.documentElement.clientWidth,
        popW = Math.min(340, vw - 24);
      let left = rect.left + sx;
      const maxLeft = sx + vw - popW - 12;
      (left > maxLeft && (left = maxLeft), left < sx + 12 && (left = sx + 12));
      const top = rect.bottom + sy + 8,
        originX = Math.max(8, Math.min(popW - 8, rect.left + sx - left + rect.width / 2));
      ((colorPreviewEl.style.left = left + 'px'), (colorPreviewEl.style.top = top + 'px'), (colorPreviewEl.style.transformOrigin = originX + 'px -8px'));
    }
    const designSides = getDesignSides(),
      sides = designSides.length ? designSides : [state.side || 'Front'];
    let idx = sides.indexOf('Front');
    (idx < 0 && (idx = 0),
      (_previewState = { color, sides, idx }),
      colorPreviewEl.classList.toggle('has-multi', sides.length > 1),
      colorPreviewEl.classList.add('show'),
      await renderPreviewSide());
  }
  async function renderPreviewSide(silent) {
    const { color, sides, idx } = _previewState;
    if (!color || !sides.length) return;
    const side = sides[idx],
      myToken = ++_colorPreviewToken;
    (cpLabelEl && (cpLabelEl.textContent = side),
      silent ||
        (colorPreviewImg && (colorPreviewImg.style.display = 'none'),
        colorPreviewLoading && ((colorPreviewLoading.style.display = 'block'), (colorPreviewLoading.textContent = 'Generating preview\u2026'))));
    let src = null,
      isRaw = !1;
    try {
      if ((state.designs[side] && state.designs[side].data && (src = await captureMockup(side, color, { width: 800, mimeType: 'image/png', pad: 1.2, caption: !1 })), !src)) {
        const capData = imageFor(color, side);
        ((src = capData && capData.url ? capData.url : null), (isRaw = !!src));
      }
    } catch (err) {
      console.error('[color preview] generation failed:', err);
    }
    if (myToken !== _colorPreviewToken) return;
    if (!src) {
      colorPreviewLoading && ((colorPreviewLoading.style.display = ''), (colorPreviewLoading.textContent = 'No preview available.'));
      return;
    }
    const probe = new Image();
    ((probe.onload = () => {
      myToken === _colorPreviewToken &&
        (colorPreviewImg.classList.toggle('is-raw', isRaw),
        (colorPreviewImg.src = src),
        (colorPreviewImg.style.display = ''),
        colorPreviewLoading && (colorPreviewLoading.style.display = 'none'));
    }),
      (probe.onerror = () => {
        myToken === _colorPreviewToken && colorPreviewLoading && ((colorPreviewLoading.style.display = ''), (colorPreviewLoading.textContent = "Couldn't load preview."));
      }),
      (probe.src = src));
  }
  (cpPrevBtn &&
    (cpPrevBtn.onclick = (e) => {
      e.stopPropagation();
      const s = _previewState;
      s.sides.length && ((s.idx = (s.idx - 1 + s.sides.length) % s.sides.length), renderPreviewSide(!0));
    }),
    cpNextBtn &&
      (cpNextBtn.onclick = (e) => {
        e.stopPropagation();
        const s = _previewState;
        s.sides.length && ((s.idx = (s.idx + 1) % s.sides.length), renderPreviewSide(!0));
      }));
  function closeColorPreview() {
    colorPreviewEl && (_colorPreviewToken++, colorPreviewEl.classList.remove('show'), colorPreviewImg && ((colorPreviewImg.src = ''), (colorPreviewImg.style.display = 'none')));
  }
  document.addEventListener('click', (e) => {
    !colorPreviewEl || !colorPreviewEl.classList.contains('show') || colorPreviewEl.contains(e.target) || closeColorPreview();
  });
  const _reanchorPreview = () => {
    colorPreviewEl && colorPreviewEl.classList.contains('show') && closeColorPreview();
  };
  (window.addEventListener('scroll', _reanchorPreview, { passive: !0 }),
    window.addEventListener('resize', _reanchorPreview),
    colorPreviewEl && colorPreviewEl.addEventListener('click', (e) => e.stopPropagation()),
    document.addEventListener('keydown', (e) => {
      e.key === 'Escape' && modal.classList.remove('show');
    }));
  const breakdownLink = $('#ldm-breakdown-link'),
    shippingLink = $('#ldm-shipping-link'),
    shippingTooltipEl = $('#ldm-shipping-tooltip');
  function setSummaryDisclosure(trigger, panel, open) {
    (panel.classList.toggle('show', open), trigger.setAttribute('aria-expanded', String(open)));
  }
  ((breakdownLink.onclick = (e) => {
    (e.preventDefault(), setSummaryDisclosure(breakdownLink, breakdownEl, !breakdownEl.classList.contains('show')));
  }),
    (shippingLink.onclick = (e) => {
      (e.preventDefault(), setSummaryDisclosure(shippingLink, shippingTooltipEl, !shippingTooltipEl.classList.contains('show')));
    }),
    (document.onclick = (e) => {
      (!e.target.closest('#ldm-breakdown-link') && !e.target.closest('#ldm-breakdown') && setSummaryDisclosure(breakdownLink, breakdownEl, !1),
        !e.target.closest('#ldm-shipping-link') && !e.target.closest('#ldm-shipping-tooltip') && setSummaryDisclosure(shippingLink, shippingTooltipEl, !1));
    }),
    document.addEventListener('keydown', (e) => {
      e.key === 'Escape' && (setSummaryDisclosure(breakdownLink, breakdownEl, !1), setSummaryDisclosure(shippingLink, shippingTooltipEl, !1));
    }));
  function showError(msg) {
    ((errorEl.textContent = msg), errorEl.classList.add('show'));
  }
  function hideError() {
    errorEl.classList.remove('show');
  }
  let _bgModel = null,
    _bgProcessor = null,
    _bgModelPromise = null,
    _bgDevice = 'wasm';
  function ensureBgModel() {
    return (
      _bgModelPromise ||
      ((_bgModelPromise = (async () => {
        const { AutoModel, AutoProcessor, env, RawImage } = await import('https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.4.1/+esm');
        env.allowLocalModels = !1;
        let webgpu = !1;
        try {
          webgpu = !!(navigator.gpu && (await navigator.gpu.requestAdapter()));
        } catch {}
        const attempts = webgpu ? [{ device: 'webgpu', dtype: 'fp16' }, { dtype: 'q8' }] : [{ dtype: 'q8' }, {}];
        let lastErr = null;
        for (const opts of attempts)
          try {
            const [model, processor] = await Promise.all([
              AutoModel.from_pretrained('briaai/RMBG-1.4', Object.assign({ config: { model_type: 'custom' } }, opts)),
              AutoProcessor.from_pretrained('briaai/RMBG-1.4'),
            ]);
            ((_bgModel = model), (_bgProcessor = processor), (_bgModel._RawImage = RawImage), (_bgDevice = opts.device || 'wasm'));
            return;
          } catch (e) {
            ((lastErr = e), console.warn('[bg] load attempt failed', opts, e));
          }
        throw ((_bgModelPromise = null), lastErr);
      })()),
      _bgModelPromise)
    );
  }
  function warmBgModel() {
    const c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g|3g/.test(c.effectiveType || ''))) return;
    const kick = () => {
      ensureBgModel().catch(() => {});
    };
    'requestIdleCallback' in window ? requestIdleCallback(kick, { timeout: 4e3 }) : setTimeout(kick, 1500);
  }
  async function bgInferenceSource(dataUrl) {
    const img = await new Promise((res, rej) => {
        const i = new Image();
        ((i.onload = () => res(i)), (i.onerror = rej), (i.src = dataUrl));
      }),
      maxDim = Math.max(img.naturalWidth, img.naturalHeight);
    if (maxDim <= 1024) return dataUrl;
    const scale = 1024 / maxDim,
      c = document.createElement('canvas');
    return (
      (c.width = Math.round(img.naturalWidth * scale)),
      (c.height = Math.round(img.naturalHeight * scale)),
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height),
      c.toDataURL('image/png')
    );
  }
  const removeBgBtn = $('#ldm-remove-bg'),
    removeBgText = $('#ldm-remove-bg-text');
  function colorKeyRemove(dataUrl, tolerance) {
    return (
      (tolerance = tolerance || 60),
      new Promise((resolve, reject) => {
        const img = new Image();
        ((img.onload = () => {
          const c = document.createElement('canvas');
          ((c.width = img.width), (c.height = img.height));
          const ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const px = ctx.getImageData(0, 0, c.width, c.height),
            d = px.data,
            w = c.width,
            h = c.height,
            edgeSamples = [];
          for (let x = 0; x < w; x++) (edgeSamples.push((0 * w + x) * 4), edgeSamples.push(((h - 1) * w + x) * 4));
          for (let y = 0; y < h; y++) (edgeSamples.push((y * w + 0) * 4), edgeSamples.push((y * w + (w - 1)) * 4));
          const buckets = {};
          for (const idx of edgeSamples) {
            const br2 = d[idx] >> 4,
              bg = d[idx + 1] >> 4,
              bb2 = d[idx + 2] >> 4,
              key = `${br2},${bg},${bb2}`;
            buckets[key] = (buckets[key] || 0) + 1;
          }
          let bestKey = null,
            bestCount = 0;
          for (const [k, v] of Object.entries(buckets)) v > bestCount && ((bestCount = v), (bestKey = k));
          const [br, bg2, bb] = bestKey.split(',').map((n) => (parseInt(n) << 4) + 8);
          for (let i = 0; i < d.length; i += 4) {
            const dr = d[i] - br,
              dg = d[i + 1] - bg2,
              db = d[i + 2] - bb,
              dist = Math.sqrt(dr * dr + dg * dg + db * db);
            if (dist < tolerance) d[i + 3] = 0;
            else if (dist < tolerance * 1.5) {
              const fade = (dist - tolerance) / (tolerance * 0.5);
              d[i + 3] = Math.round(d[i + 3] * Math.min(1, fade));
            }
          }
          (ctx.putImageData(px, 0, 0), resolve(c.toDataURL('image/png')));
        }),
          (img.onerror = reject),
          (img.src = dataUrl));
      })
    );
  }
  (removeBgBtn &&
    removeBgBtn.addEventListener(
      'pointerdown',
      () => {
        ensureBgModel().catch(() => {});
      },
      { once: !0 },
    ),
    removeBgBtn &&
      (removeBgBtn.onclick = async () => {
        const d = state.designs[state.side];
        if (!(!d.data || d._bgRemoved)) {
          (removeBgBtn.classList.add('processing'), (removeBgText.textContent = 'Removing background...'));
          try {
            let resultUrl = await colorKeyRemove(d.data, 60);
            (_bgModel || (removeBgText.textContent = 'Loading AI model...'), await ensureBgModel(), (removeBgText.textContent = 'Refining with AI...'));
            const RawImage = _bgModel._RawImage,
              aiImg = await RawImage.fromURL(await bgInferenceSource(d.data)),
              { pixel_values } = await _bgProcessor(aiImg),
              { output } = await _bgModel({ input: pixel_values }),
              combImg = await new Promise((resolve, reject) => {
                const i = new Image();
                ((i.onload = () => resolve(i)), (i.onerror = reject), (i.src = resultUrl));
              }),
              finalCanvas = document.createElement('canvas');
            ((finalCanvas.width = combImg.naturalWidth), (finalCanvas.height = combImg.naturalHeight));
            const fCtx = finalCanvas.getContext('2d', { willReadFrequently: !0 }),
              aiMask = await RawImage.fromTensor(output[0].mul(255).to('uint8')).resize(finalCanvas.width, finalCanvas.height);
            fCtx.drawImage(combImg, 0, 0);
            const pxData = fCtx.getImageData(0, 0, finalCanvas.width, finalCanvas.height),
              px = pxData.data;
            for (let i = 0; i < aiMask.data.length; i++) px[4 * i + 3] = Math.min(px[4 * i + 3], aiMask.data[i]);
            fCtx.putImageData(pxData, 0, 0);
            const newDataUrl = finalCanvas.toDataURL('image/png');
            ((d.data = newDataUrl),
              ((d._bgRemoved = true, d.threadSource = newDataUrl, d.defaultTint = null, window.LiftDownThreadColors.clear(d))),
              (d._fullBase = null),
              (d._fullEdited = null),
              (d._fullEditedImg = null),
              (d._cropRect = null),
              (d._tint = null),
              (_lastSavedHash = null),
              (void ldCapThreadPreview(d, displayedColor())),
              logo.classList.add('active', 'selected'),
              updateUploadUI(),
              removeBgBtn.classList.remove('processing'),
              removeBgBtn.classList.add('done'),
              (removeBgText.textContent = 'Background removed \u2713'),
              trackEvent('BackgroundRemoved', { side: state.side }));
          } catch (e) {
            (console.error('Background removal failed:', e),
              removeBgBtn.classList.remove('processing'),
              (removeBgText.textContent = 'Remove background'),
              showError('Background removal failed \u2014 please try again.'));
          }
        }
      }));
  function showShareToast(msg) {
    ((shareToast.textContent = msg || 'Link copied to clipboard!'), shareToast.classList.add('show'), setTimeout(() => shareToast.classList.remove('show'), 2500));
  }
  let previewSwipeStart = null;
  const VIEWS = ['Front', 'Back', 'Side'];
  (stageEl.addEventListener(
    'touchstart',
    (e) => {
      e.target.closest('.ldm-artwork-controls, .ldm-thread-trigger--stage') ||
        e.target.closest('.ldm-logo') ||
        e.target.closest('.ldm-inline-text') ||
        e.target.closest('.ldm-stage-btns') ||
        (previewSwipeStart = { x: e.changedTouches[0].screenX, y: e.changedTouches[0].screenY });
    },
    { passive: !0 },
  ),
    stageEl.addEventListener(
      'touchend',
      (e) => {
        if (
          e.target.closest('.ldm-artwork-controls, .ldm-thread-trigger--stage') ||
          e.target.closest('.ldm-logo') ||
          e.target.closest('.ldm-inline-text') ||
          e.target.closest('.ldm-stage-btns') ||
          !previewSwipeStart
        )
          return;
        const t = e.changedTouches[0],
          diff = previewSwipeStart.x - t.screenX,
          dy = Math.abs(previewSwipeStart.y - t.screenY);
        if (((previewSwipeStart = null), Math.abs(diff) < 50 || Math.abs(diff) < dy * 1.5)) return;
        const currentIdx = VIEWS.indexOf(state.side);
        (diff > 0 ? (state.side = VIEWS[(currentIdx + 1) % VIEWS.length]) : (state.side = VIEWS[(currentIdx - 1 + VIEWS.length) % VIEWS.length]),
          syncInlineTextForSide(),
          syncViewBtns(),
          renderTabs(),
          updateStage(),
          updateUploadUI());
      },
      { passive: !0 },
    ));
  const saveForm = $('#ldm-save-form'),
    saveEmailInput = $('#ldm-save-email'),
    saveSubmit = $('#ldm-save-submit'),
    saveSuccess = $('#ldm-save-success'),
    saveError = $('#ldm-save-error'),
    saveLinkResult = $('#ldm-save-link-result'),
    saveLinkUrl = $('#ldm-save-link-url'),
    copyLinkBtn = $('#ldm-copy-link-btn');
  copyLinkBtn &&
    (copyLinkBtn.onclick = () => {
      const url = saveLinkUrl?.value;
      url &&
        navigator.clipboard.writeText(url).then(() => {
          ((copyLinkBtn.textContent = 'Copied!'),
            showShareToast('Design link copied \u2014 share it with your team!'),
            setTimeout(() => {
              copyLinkBtn.textContent = 'Copy link';
            }, 2500));
        });
    });
  function compressForSave(dataUrl, maxDim = 700) {
    return new Promise((resolve) => {
      if (!dataUrl) {
        resolve(null);
        return;
      }
      const img = new Image();
      ((img.onload = () => {
        if (img.width <= maxDim && img.height <= maxDim && dataUrl.length < 15e4) {
          resolve(dataUrl);
          return;
        }
        const c = document.createElement('canvas'),
          s = Math.min(maxDim / img.width, maxDim / img.height, 1);
        ((c.width = Math.round(img.width * s)), (c.height = Math.round(img.height * s)));
        const ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, c.width, c.height);
        let hasAlpha = !1;
        try {
          const px = ctx.getImageData(0, 0, c.width, c.height).data;
          for (let i = 3; i < px.length; i += 4)
            if (px[i] < 255) {
              hasAlpha = !0;
              break;
            }
        } catch {
          hasAlpha = !0;
        }
        resolve(hasAlpha ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.85));
      }),
        (img.onerror = () => resolve(dataUrl)),
        (img.src = dataUrl));
    });
  }
  function buildDesignUrl(designId, sig) {
    return window.location.origin + window.location.pathname + '?design=' + encodeURIComponent(designId) + (sig ? '&sig=' + encodeURIComponent(sig) : '');
  }
  let _lastSavedId = null,
    _lastSavedSig = null,
    _lastSavedHash = null,
    _lastSavedEmail = null;
  function makeDispJpeg(dataUrl) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      ((img.onload = () => {
        const long = Math.max(img.width, img.height),
          s = Math.min(1, 1600 / long),
          c = document.createElement('canvas');
        ((c.width = Math.max(1, Math.round(img.width * s))),
          (c.height = Math.max(1, Math.round(img.height * s))),
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height),
          resolve(c.toDataURL('image/jpeg', 0.82)));
      }),
        (img.onerror = reject),
        (img.src = dataUrl));
    });
  }
  let _lastCloudMockups = null;
  /* Insert inside the configurator closure, immediately before stateHash. */
/* Insert inside the configurator closure, immediately before stateHash. */
/* Insert inside the configurator closure, immediately before stateHash. */
const ldThreadBitmapRecords = new WeakMap();
let ldThreadBitmapVersion = 0;
let ldThreadAutoSaveSequence = 0;

function ldThreadSelectedColors() {
  const colors = mixOn() ? state.mix.filter(row => row.qty > 0).map(row => row.color) : [state.color];
  return [...new Set(colors.filter(color => COLORS.includes(color)))];
}

function ldThreadHasOverrides() {
  return getDesignSides().some(side => {
    const d = state.designs[side];
    return Object.keys(window.LiftDownThreadColors.sanitizeMap(d.threadByColor, { colors: COLORS, mode: d.mode })).length > 0;
  });
}

function ldThreadBitmapKey(d) {
  const next = [d.data || '', d.threadSource || '', d._fullBase || '', JSON.stringify(d._cropRect || null), d.mode || 'file'];
  const prior = ldThreadBitmapRecords.get(d);
  if (prior && next.every((value, index) => value === prior.values[index])) return prior.version;
  const version = ++ldThreadBitmapVersion;
  ldThreadBitmapRecords.set(d, { values: next, version });
  return version;
}

function ldThreadFingerprint() {
  return JSON.stringify(getDesignSides().map(side => {
    const d = state.designs[side];
    const metadata = window.LiftDownThreadColors.metadata(d, { colors: COLORS });
    return [side, ldThreadBitmapKey(d), metadata.threadByColor, metadata.defaultTint];
  }));
}

function ldThreadRestoreMetadata(d, saved, localSource, localData) {
  if (!saved || !Object.prototype.hasOwnProperty.call(saved, 'threadByColor')) return;
  const mode = saved.mode || d.mode || 'file';
  d.threadByColor = window.LiftDownThreadColors.sanitizeMap(saved.threadByColor, { colors: COLORS, mode });
  d.defaultTint = mode === 'text' ? null : window.LiftDownThreadColors.normalizeHex(saved.defaultTint);
  d.threadSource = mode === 'text' ? null : (typeof localSource === 'string' ? localSource : typeof saved.threadSource === 'string' ? saved.threadSource : null);
  if (mode !== 'text' && d.threadSource) {
    d._fullBase = d.threadSource;
    d._cropRect = null;
    d._tint = d.defaultTint;
    // Source and legacy display data may have different export resolutions. Crop
    // coordinates must always use source geometry, never the larger saved preview.
    d._fullEdited = d.threadSource;
    d._fullEditedImg = null;
    d._editSeq = (d._editSeq || 0) + 1;
    const source = d.threadSource;
    const editSequence = d._editSeq;
    const tint = d._tint;
    d._threadBaselineReady = (async () => {
      const baseline = tint ? await window.LiftDownThreadColors.render({ mode: 'file', data: source, threadSource: source, threadByColor: { baseline: tint } }, 'baseline') : source;
      if (d._fullBase === source && d._editSeq === editSequence) {
        d._fullEdited = baseline;
        d._fullEditedImg = null;
      }
      return baseline;
    })().catch(() => source);
  }
  window.LiftDownThreadColors.clear(d);
}

function ldThreadProps(color) {
  if (!ldThreadHasOverrides()) return {};
  const properties = {};
  for (const side of getDesignSides()) {
    const descriptor = window.LiftDownThreadColors.describe(state.designs[side], color);
    properties[side + ' Thread Color'] = descriptor.hex || 'Original colors';
  }
  return properties;
}

async function ldThreadFitRaster(source, maxWidth = 700) {
  if (typeof source !== 'string' || !source) throw new Error('Your thread-color preview could not be prepared. Please try again.');
  let result = await compressForSave(source, maxWidth);
  const bytes = value => Math.ceil(((value.split(',')[1] || '').length * 3) / 4);
  for (const width of [600, 480, 360]) {
    if (bytes(result) <= 1500000) break;
    result = await compressForSave(source, Math.min(maxWidth, width));
  }
  if (!/^data:image\/(png|jpeg|webp);base64,/i.test(result) || bytes(result) > 1500000) throw new Error('Your thread-color preview could not be saved. Please try a smaller artwork file.');
  return result;
}

async function ldThreadSavedMetadata(d) {
  const metadata = window.LiftDownThreadColors.metadata(d, { colors: COLORS });
  if (d.mode !== 'text' && Object.keys(metadata.threadByColor).length) {
    metadata.threadSource = await ldThreadFitRaster(await window.LiftDownThreadColors.originalSource(d));
  } else {
    delete metadata.threadSource;
  }
  return metadata;
}

function ldThreadLocalMetadata(d) {
  const metadata = window.LiftDownThreadColors.metadata(d, { colors: COLORS });
  delete metadata.threadSource;
  return metadata;
}

async function ldThreadBuildAssets(sides) {
  const colors = ldThreadSelectedColors();
  if (!colors.length || !sides.length) throw new Error('Choose a cap color and add your design before saving.');
  const colorDesigns = {};
  // Sequential colors bound peak canvas/base64 memory on mobile.
  for (const color of colors) {
    colorDesigns[color] = {};
    for (const side of sides) colorDesigns[color][side] = await ldThreadFitRaster(await window.LiftDownThreadColors.render(state.designs[side], color));
  }
  return colorDesigns;
}

async function ldThreadSaveBody(payload, featureEnabled) {
  let body = JSON.stringify(payload);
  if (!featureEnabled) return body;
  const bytes = text => new TextEncoder().encode(text).byteLength;
  const rowBytes = () => bytes(JSON.stringify({ ...payload, assets: undefined }));
  // Keep original artwork and legacy design data; reduce only new preview
  // derivatives (and duplicate display mockups) when a large color mix needs it.
  for (const width of [600, 480, 360, 280, 220, 160]) {
    if (bytes(body) <= 5000000 && rowBytes() <= 3800000) break;
    for (const sides of Object.values(payload.assets.colorDesigns || {})) {
      for (const side of Object.keys(sides)) sides[side] = await compressForSave(sides[side], width);
    }
    for (const group of [payload.assets.mockups, payload.assets.mockupsDisp]) {
      for (const side of Object.keys(group || {})) group[side] = await compressForSave(group[side], Math.max(480, width));
    }
    for (const design of Object.values(payload.designs || {})) {
      if (design.threadSource) design.threadSource = await compressForSave(design.threadSource, width);
    }
    body = JSON.stringify(payload);
  }
  if (bytes(body) > 5000000 || rowBytes() > 3800000) throw new Error('This design is too large to save with all thread-color previews. Your design is still here; please use a smaller artwork file and try again.');
  return body;
}

function stateHash() {
    const sides = getDesignSides(),
      splitKey = state.mix ? JSON.stringify(state.mix.map((r) => [r.color, r.qty, r.s, r.xl])) : state.sizes.s || state.sizes.xl ? `S${state.sizes.s}XL${state.sizes.xl}` : '',
      noteKey = ((specialRequestsEl && specialRequestsEl.value) || '').trim().slice(0, 500);
    return (
      (state.color +
      '|' +
      state.qty +
      '|' +
      splitKey +
      '|' +
      noteKey +
      '|' +
      sides.join(',') +
      '|' +
      sides
        .map((s) => {
          const d = state.designs[s],
            p = d.placement || {},
            t = d.textConfig || {};
          return (
            (d.data || '').length +
            '@' +
            [Math.round(p.x || 0), Math.round(p.y || 0), Math.round(p.w || 0), Math.round(p.r || 0)].join(',') +
            '|' +
            (t.text || '') +
            (t.font || '') +
            (t.color || '') +
            (t.size || '') +
            (t.curve || '')
          );
        })
        .join('|')) + (ldThreadHasOverrides() ? '|thread:' + ldThreadFingerprint() : '')
    );
  }
  
  const LD_SAVE_REQUEST_TIMEOUT_MS = 100000;
  const LD_CHECKOUT_REQUEST_TIMEOUT_MS = 70000;
  const LD_PREPARATION_TIMEOUT_MS = 30000;
  const LD_LOAD_REQUEST_TIMEOUT_MS = 70000;
  const LD_INQUIRY_UPLOAD_TIMEOUT_MS = 100000;
  const LD_INQUIRY_REQUEST_TIMEOUT_MS = 70000;
  async function ldRunPreparation(work) {
    let expired = false;
    let timer;
    const check = () => {
      if (expired) throw new Error('Save timed out — please try again.');
    };
    try {
      return await Promise.race([
        Promise.resolve().then(() => work(check)),
        new Promise((resolve, reject) => {
          timer = setTimeout(() => {
            expired = true;
            reject(new Error('Save timed out — please try again.'));
          }, LD_PREPARATION_TIMEOUT_MS);
        })
      ]);
    } finally {
      clearTimeout(timer);
    }
  }
  async function ldFetchWithDeadline(url, options, timeoutMs, mode = 'json') {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    let bodyConsumed = false;
    try {
      const resp = await fetch(url, { ...options, signal: controller.signal });
      let data = null;
      if (mode === 'json' || (mode === 'success-json' && resp.ok)) {
        data = await resp.json();
        bodyConsumed = true;
      }
      return { resp, data };
    } finally {
      if (!bodyConsumed) controller.abort();
      clearTimeout(timer);
    }
  }
  async function ldFetchCheckout(options, timeoutMs = LD_CHECKOUT_REQUEST_TIMEOUT_MS, successOnly = false) {
    return ldFetchWithDeadline(NETLIFY_URL, options, timeoutMs, successOnly ? 'success-json' : 'json');
  }
async function saveDesignToCloud(email, fbContext) {
    const prepared = await ldRunPreparation(async (ldCheckPreparation) => {
    await prepareTextDesigns();
ldCheckPreparation();
const threadFeature = ldThreadHasOverrides();
    const hash = stateHash();
    if (_lastSavedId && _lastSavedHash === hash && !email) return { cached: { id: _lastSavedId, sig: _lastSavedSig, url: buildDesignUrl(_lastSavedId, _lastSavedSig) }, hash, threadFeature };
    const designPayload = {},
      capW = stageImg.offsetWidth || stageEl.offsetWidth * 0.85;
    for (const side of ['Front', 'Back', 'Side']) {
      const d = state.designs[side];
      (d.data || (d.textConfig && d.textConfig.text.trim())) &&
        (designPayload[side] = ({ ...{
          data: await compressForSave(d.data),
          fileName: d.file?.name || null,
          placement: { ...d.placement, wPctCap: (d.placement.w / capW) * 100 },
          textConfig: d.textConfig,
          mode: d.mode || 'file',
        }, ...(threadFeature ? await ldThreadSavedMetadata(d) : {}) }));
    }
    const sidesForAssets = getDesignSides(),
      cloudPreset = mockupPreset(sidesForAssets.length, 'cloud'),
      mockups = {},
      originals = {},
      mockupsDisp = {},
      assetJobs = [];
    for (const side of sidesForAssets)
      assetJobs.push(
        (async () => {
          try {
            const mk = await captureMockup(side, state.color, cloudPreset);
            if (mk) {
              mockups[side] = mk;
              const _c = navigator.connection;
              if (!_c || (!_c.saveData && !/(^|-)2g|3g/.test(_c.effectiveType || '')))
                try {
                  mockupsDisp[side] = await makeDispJpeg(mk);
                } catch {}
            }
          } catch (e) {
            console.error(`[save] mockup ${state.color}/${side} failed:`, e);
          }
        })(),
      );
    for (const side of sidesForAssets) {
      const d = state.designs[side];
      d?.data &&
        assetJobs.push(
          (async () => {
            originals[side] = await compressForSave(d.data, 1200);
          })(),
        );
    }
    (await Promise.all(assetJobs), ldCheckPreparation(), (_lastCloudMockups = { color: state.color, bySide: mockups }));
    const colorDesigns = threadFeature ? await ldThreadBuildAssets(sidesForAssets) : null;
const saveBody = await ldThreadSaveBody({
      color: state.color,
      qty: state.qty,
      colorSplits: state.mix ? state.mix.map((r) => ({ color: r.color, qty: r.qty })) : void 0,
      mix: state.mix ? state.mix.map((r) => ({ color: r.color, qty: r.qty, s: r.s, xl: r.xl })) : void 0,
      sizes: state.sizes,
      specialRequests: ((specialRequestsEl && specialRequestsEl.value) || '').trim().slice(0, 500) || void 0,
      designs: designPayload,
      email: email || void 0,
      fb: fbContext || void 0,
      assets: { mockups, originals, mockupsDisp, ...(colorDesigns ? { colorDesigns } : {}) },
    }, threadFeature);
    
ldCheckPreparation();
return { saveBody, hash, threadFeature };
    });
    if (prepared.cached) return prepared.cached;
    const { saveBody, hash, threadFeature } = prepared;

    let resp = null;
    let result;
    let failureBody = '';
    for (let attempt = 1; attempt <= 2; attempt++) {
      if (threadFeature && stateHash() !== hash) throw new Error('Your design changed while its thread-color previews were being prepared. Please try saving again.');
      const saveController = new AbortController();
      const saveTimeout = setTimeout(() => saveController.abort(), LD_SAVE_REQUEST_TIMEOUT_MS);
      let responseReceived = false;
      let bodyConsumed = false;
      try {
        resp = await fetch(SAVE_DESIGN_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: saveController.signal, body: saveBody });
        responseReceived = true;
        if (resp.ok) {
          result = await resp.json();
          bodyConsumed = true;
          break;
        }
        if ([502, 503, 504].includes(resp.status) && attempt < 2) {
          console.warn(`[save-design] gateway ${resp.status}, retrying once`);
          continue;
        }
        try {
          failureBody = await resp.text();
          bodyConsumed = true;
        } catch (err) {
          if (err.name === 'AbortError') throw err;
          failureBody = '';
        }
        break;
      } catch (err) {
        const timedOut = err.name === 'AbortError';
        if (responseReceived && (!timedOut || !resp.ok)) {
          throw timedOut ? new Error('Save timed out — please try again.') : err;
        }
        resp = null;
        if (attempt === 2) throw timedOut ? new Error('Save timed out — please try again.') : err;
        console.warn('[save-design] attempt 1 failed, retrying once:', timedOut ? 'timeout' : err.message);
      } finally {
        if (!bodyConsumed) saveController.abort();
        clearTimeout(saveTimeout);
      }
    }
    if (!resp.ok) {
      const raw = failureBody;
      let serverMsg = '';
      try { serverMsg = JSON.parse(raw).error || raw; } catch { serverMsg = raw; }
      console.error('[save-design] failed:', resp.status, raw);
      throw new Error(`Save failed (${resp.status}): ${serverMsg || 'unknown error'}`);
    }

if (threadFeature && (!result.id || !result.sig)) throw new Error('Your thread-color choices could not be saved. Please try again.');
    return (
      (_lastSavedId = result.id),
      (_lastSavedSig = result.sig || null),
      (_lastSavedHash = hash),
      { id: result.id, sig: result.sig || null, url: buildDesignUrl(result.id, result.sig) }
    );
  }
  async function sendSavedDesignEmail(payload) {
    const controller = new AbortController(),
      timeout = setTimeout(() => controller.abort(), 15e3);
    try {
      const response = await fetch(EMAIL_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal, body: JSON.stringify(payload) }),
        result = await response.json().catch(() => null);
      if (!response.ok || result?.success !== !0) throw new Error(`Saved-design email was not confirmed (${response.status})`);
    } finally {
      clearTimeout(timeout);
    }
  }
  saveSubmit &&
    (saveSubmit.onclick = async () => {
      if (!getDesignSides().length) {
        ((saveError.textContent = 'Please upload a design before saving.'), saveError.classList.add('show'));
        return;
      }
      const email = saveEmailInput.value.trim();
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        ((saveError.textContent = 'Please enter a valid email address.'), saveError.classList.add('show'));
        return;
      }
      (saveError.classList.remove('show'), (saveSubmit.disabled = !0), (saveSubmit.textContent = 'Saving...'));
      const procText2 = processing.querySelector('.ldm-processing-text');
      (procText2 && (procText2.textContent = 'Saving your design'), processing.classList.add('show'));
      try {
        const sides = getDesignSides(),
          base = getBase(state.qty),
          emb = sides.length * EMB_PRICE,
          per = base + emb,
          _saveEmail = email ? email.toLowerCase() : '',
          fbEventId = genEventId('lead_save_design'),
          fbDesignSavedEventId = genEventId('ds_save_design');
        _saveEmail && ((_lastSavedEmail = _saveEmail), fbAdvancedInit(_saveEmail));
        const fbContext = {
            eventId: fbEventId,
            customEventId: fbDesignSavedEventId,
            eventSourceUrl: location.href,
            fbp: getFbp(),
            fbc: getFbc(),
            value: +(base * state.qty).toFixed(2),
            currency: 'USD',
          },
          { url: link, id: designId, sig: designSig } = await saveDesignToCloud(email || null, fbContext);
        let savedEmailSent = !1;
        if (_saveEmail) {
          const attachments = [],
            emailPreset = mockupPreset(sides.length, 'email'),
            emailExt = extForMime(emailPreset.mimeType);
          await ldRunPreparation(async (ldCheckPreparation) => { for (const side of sides)
            try {
              const mockupData = await captureMockup(side, state.color, emailPreset);
              mockupData &&
                attachments.push({
                  filename: `mockup-${side.toLowerCase()}-${state.color.replace(/\s+/g, '-').toLowerCase()}.${emailExt}`,
                  content: mockupData.split(',')[1],
                  contentType: emailPreset.mimeType,
                });
            } catch (err) {
              console.error(`Mockup failed for ${state.color}/${side}:`, err);
            } ldCheckPreparation(); });
          const savedSpecialRequests = ((specialRequestsEl && specialRequestsEl.value) || '').trim(),
            savedBaseProps = {
              'Embroidery Locations': sides.length ? sides.join(', ') : 'Front',
              'Base Price': formatMoney(base),
              'Embroidery Cost': formatMoney(emb),
              Source: 'Saved Design',
            };
          designId && (savedBaseProps['Design #'] = designId);
          let savedLineItems;
          if (mixOn())
            savedLineItems = state.mix.map((r, i) => ({
              title: `${PRODUCT_NAME} - ${r.color}`,
              quantity: r.qty,
              price: per.toFixed(2),
              taxable: !1,
              properties: Object.assign(
                { Color: r.color, Sizes: rowSizesLabel(r) },
                savedBaseProps, ldThreadProps(r.color),
                i === 0 && savedSpecialRequests ? { 'Special Requests': savedSpecialRequests.slice(0, 500) } : {},
              ),
            }));
          else {
            const sp = Object.assign({ Color: state.color, Sizes: sizesLabel() }, savedBaseProps, ldThreadProps(state.color));
            (savedSpecialRequests && (sp['Special Requests'] = savedSpecialRequests.slice(0, 500)),
              (savedLineItems = [{ title: `${PRODUCT_NAME} - ${state.color}`, quantity: state.qty, price: per.toFixed(2), taxable: !1, properties: sp }]));
          }
          const savedTags = designId ? [`design-${designId}`, 'custom-cap-saved'] : ['custom-cap-saved'];
          (mixOn() && savedTags.push('color-mix'), savedSpecialRequests && savedTags.push('has-special-requests'));
          const sV = +(per * state.qty).toFixed(2),
            sCN = `${P.title} - ${state.color}`,
            sPC = [{ id: slug(P.title) + '-' + slug(state.color), quantity: state.qty, item_price: per.toFixed(2) }],
            sIc = genEventId('ic_save_design'),
            fbSavedCheckoutContext = {
              eventId: sIc,
              eventSourceUrl: location.href,
              fbp: getFbp(),
              fbc: getFbc(),
              email: _saveEmail || void 0,
              value: sV,
              currency: 'USD',
              contentName: sCN,
              contents: sPC,
            };
          typeof fbq == 'function' &&
            fbq(
              'track',
              'InitiateCheckout',
              { content_name: sCN, content_category: 'Custom Caps', content_ids: sPC.map((c) => c.id), contents: sPC, num_items: state.qty, value: sV, currency: 'USD' },
              { eventID: sIc },
            );
          let checkoutUrl = '';
          try {
const { resp: draftResp, data: draftData } = await ldFetchCheckout({ method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
                  line_items: savedLineItems,
                  customer_note: `Saved design: ${state.qty} units, ${sides.length ? sides.join(', ') : 'Front'} embroidery${designId ? ` \u2014 Design ${designId}` : ''}${
                    mixOn()
                      ? `

Color mix:
${orderMixDetail()}`
                      : `
Sizes: ${sizesLabel()}`
                  }${
                    savedSpecialRequests
                      ? `

Special requests:
${savedSpecialRequests.slice(0, 500)}`
                      : ''
                  }`,
                  email: _saveEmail || void 0,
                  tags: savedTags,
                  fb: fbSavedCheckoutContext,
                  sides_count: sides.length,
                }) }, 8000, true);
if (draftResp.ok) checkoutUrl = draftData.invoice_url || '';
} catch (draftErr) {
            console.error('Draft order for save email skipped:', draftErr.name === 'AbortError' ? 'timeout' : draftErr);
          }
          procText2 && (procText2.textContent = 'Sending your email');
          try {
            (await sendSavedDesignEmail({
              to: email,
              bcc: 'wholesale@liftdown.com',
              replyTo: 'wholesale@liftdown.com',
              subject: `Your saved design${designId ? ` - ${designId}` : ''}`,
              html: window.LiftDownConfiguratorEmails.saved({
                product: PRODUCT_NAME,
                color: state.color,
                mix: mixOn() ? state.mix.map((row) => `${row.color}: ${row.qty}${rowSizesSuffix(row)}`) : [],
                sizes: sizesLabel(),
                quantity: state.qty,
                placements: sides.join(', '),
                reference: designId,
                unitPrice: formatMoney(per),
                subtotal: formatMoney(per * state.qty),
                instructions: savedSpecialRequests.slice(0, 500),
                designURL: link,
                checkoutURL: checkoutUrl,
                attachmentCount: attachments.length,
              }),
              attachments,
            }),
              (savedEmailSent = !0));
          } catch (emailErr) {
            console.error('[email] saved-design email failed:', emailErr);
          }
        }
        (processing.classList.remove('show'), procText2 && (procText2.textContent = 'Preparing your order'));
        const successTextEl = saveSuccess.querySelector('.ldm-save-success-text');
        if (
          (successTextEl &&
            (successTextEl.textContent = savedEmailSent
              ? 'Link sent! Check your inbox.'
              : _saveEmail
                ? 'Design saved, but we could not confirm the email was sent. Copy your link below.'
                : 'Design saved! Copy your link below.'),
          saveSuccess.classList.add('show'),
          (saveForm.style.display = 'none'),
          (saveSubmit.disabled = !1),
          (saveSubmit.textContent = 'Save & Get Link'),
          savedEmailSent)
        )
          try {
            localStorage.removeItem(LS_KEY);
          } catch {}
        (typeof gtag == 'function' &&
          gtag('event', 'generate_lead', { event_category: 'Save Design', event_label: state.color + ' - qty ' + state.qty, value: base * state.qty, currency: 'USD' }),
          trackEvent('DesignSaved', { color: state.color, qty: state.qty, sides: getDesignSides().length, design_id: designId }, fbDesignSavedEventId),
          saveLinkResult && saveLinkUrl && ((saveLinkUrl.value = link), (saveLinkResult.style.display = 'block')));
      } catch (err) {
        console.error('[save-design] failed:', err);
        try {
          trackEvent('DesignSaveFailed', { message: String((err && err.message) || err).slice(0, 120) });
        } catch {}
        (processing.classList.remove('show'), procText2 && (procText2.textContent = 'Preparing your order'));
        const _saveMsg = String((err && err.message) || '');
        ((saveError.textContent = /timed out|too large|Too many/i.test(_saveMsg)
          ? _saveMsg + ' You can also email your design to wholesale@liftdown.com and we will set it up for you.'
          : 'Something went wrong. Please try again, or email your design to wholesale@liftdown.com and we will set it up for you.'),
          saveError.classList.add('show'),
          (saveSubmit.disabled = !1),
          (saveSubmit.textContent = 'Save & Get Link'));
      }
    });
  async function restoreFromURL() {
    const params = new URLSearchParams(window.location.search),
      designId = params.get('design'),
      sig = params.get('sig');
    if (designId)
      {
const procText2 = processing.querySelector('.ldm-processing-text');
try {
        
        (procText2 && (procText2.textContent = 'Loading your design'), processing.classList.add('show'));
        const loadUrl = `${LOAD_DESIGN_URL}?id=${encodeURIComponent(designId)}${sig ? '&sig=' + encodeURIComponent(sig) : ''}`;
const { resp, data: result } = await ldFetchWithDeadline(loadUrl, {}, LD_LOAD_REQUEST_TIMEOUT_MS, 'success-json');
        if (!resp.ok) throw new Error('Design not found');
        
        sig && ((_lastSavedId = designId), (_lastSavedSig = sig));
        const saved = result.data;
        if (
          (saved.color && COLORS.includes(saved.color) && (state.color = saved.color),
          saved.qty && saved.qty >= 25 && saved.qty <= 99999 && ((state.qty = saved.qty), (qtyEl.value = saved.qty)),
          Array.isArray(saved.mix) && saved.mix.length)
        ) {
          const rows = saved.mix
            .filter((r) => r && COLORS.includes(r.color))
            .map((r) => ({ color: r.color, qty: Math.min(99999, Math.max(25, r.qty | 0)), s: Math.max(0, r.s | 0), xl: Math.max(0, r.xl | 0) }));
          state.mix = rows.length ? rows : null;
        } else if (Array.isArray(saved.colorSplits) && saved.colorSplits.length > 1) {
          const rows = saved.colorSplits.filter((r) => r && COLORS.includes(r.color)).map((r) => ({ color: r.color, qty: Math.min(99999, Math.max(25, r.qty | 0)), s: 0, xl: 0 }));
          state.mix = rows.length > 1 ? rows : null;
        }
        if (
          ((mixPreviewColor = null),
          mixOn() && !state.mix.some((row) => row.color === state.color) && (state.color = state.mix[0].color),
          saved.sizes && ((state.sizes = { s: Math.max(0, saved.sizes.s | 0), xl: Math.max(0, saved.sizes.xl | 0) }), (state.sizes.s || state.sizes.xl) && openGlobalSizes()),
          typeof saved.specialRequests == 'string' &&
            specialRequestsEl &&
            ((specialRequestsEl.value = saved.specialRequests), saved.specialRequests.trim() && specialRequestsWrap && setSpecialRequestsExpanded(!0)),
          saved.designs)
        ) {
          const capW = stageImg.offsetWidth || stageEl.offsetWidth * 0.85;
          for (const side of ['Front', 'Back', 'Side']) {
            const sd = saved.designs[side];
            if (sd) {
              const d = state.designs[side];
ldThreadRestoreMetadata(d, sd);
              (sd.data && (d.data = sd.data),
                sd.placement &&
                  ((d.placement = { ...d.placement, ...sd.placement }),
                  sd.placement.wPctCap
                    ? (d.placement.w = Math.round((sd.placement.wPctCap * capW) / 100))
                    : sd.placement.wPct && (d.placement.w = Math.round((sd.placement.wPct * stageEl.offsetWidth) / 100))),
                sd.textConfig && (d.textConfig = { ...d.textConfig, ...sd.textConfig }),
                sd.mode && (d.mode = sd.mode),
                sd.fileName ? (d.file = { name: sd.fileName, type: '' }) : sd.data && (d.file = { name: 'Saved design', type: '' }));
            }
          }
        }
        ((_lastSavedId = designId),
          (_lastSavedHash = stateHash()),
          renderSwatches(),
          renderTabs(),
          updateStage(),
          updateUploadUI(),
          renderMix(),
          updatePricing(),
          syncInlineTextForSide(),
          processing.classList.remove('show'),
          procText2 && (procText2.textContent = 'Preparing your order'));
        return;
      } catch (e) {
        (console.error('Failed to load saved design:', e), processing.classList.remove('show'), procText2 && (procText2.textContent = 'Preparing your order'));
      }
}
    const colorParam = params.get('color'),
      qtyParam = params.get('qty');
    if ((colorParam && setPreviewColor(colorParam) && (renderSwatches(), updateStage()), qtyParam)) {
      const q = parseInt(qtyParam);
      q >= 25 && q <= 99999 && ((state.qty = q), (qtyEl.value = q), updatePricing());
    }
  }
  function mockupPreset(count, target) {
    return target === 'cloud'
      ? count <= 4
        ? { width: 1200, mimeType: 'image/jpeg', quality: 0.85 }
        : count <= 16
          ? { width: 900, mimeType: 'image/jpeg', quality: 0.8 }
          : { width: 700, mimeType: 'image/jpeg', quality: 0.75 }
      : count <= 4
        ? { width: 1200, mimeType: 'image/jpeg', quality: 0.88 }
        : count <= 16
          ? { width: 1e3, mimeType: 'image/jpeg', quality: 0.82 }
          : { width: 800, mimeType: 'image/jpeg', quality: 0.75 };
  }
  const extForMime = (m) => (m === 'image/jpeg' ? 'jpg' : 'png');
  async function captureMockup(side, color, options = {}) {
const ldThreadCaptureColor = color || state.color;
let ldThreadCaptureData;

    return (
      (await prepareTextDesigns(), ldThreadCaptureData = await window.LiftDownThreadColors.render(state.designs[side], ldThreadCaptureColor)),
      new Promise((resolve, reject) => {
        const d = state.designs[side];
        if (!ldThreadCaptureData) {
          resolve(null);
          return;
        }
        const mockupColor = ldThreadCaptureColor,
          width = options.width || 1600,
          stageRect = stageEl.getBoundingClientRect(),
          stageAR = stageRect.width > 0 && stageRect.height > 0 ? stageRect.height / stageRect.width : 0.75,
          height = Math.round(width * stageAR),
          mimeType = options.mimeType || 'image/png',
          quality = options.quality !== void 0 ? options.quality : 1,
          pad = options.pad !== void 0 ? options.pad : 0.85,
          showCaption = options.caption !== !1,
          canvas = document.createElement('canvas'),
          ctx = canvas.getContext('2d');
        ((canvas.width = width), (canvas.height = height), (ctx.fillStyle = '#e7e2df'), ctx.fillRect(0, 0, canvas.width, canvas.height));
        const capData = imageFor(mockupColor, side, Math.max(1200, width)),
          capImg = new Image();
        ((capImg.crossOrigin = 'anonymous'),
          (capImg.onload = () => {
            const maxW = canvas.width * pad,
              maxH = canvas.height * pad,
              scale = Math.min(maxW / capImg.naturalWidth, maxH / capImg.naturalHeight),
              capW = capImg.naturalWidth * scale,
              capH = capImg.naturalHeight * scale,
              capX = (canvas.width - capW) / 2,
              capY = (canvas.height - capH) / 2;
            capData.flip
              ? (ctx.save(), ctx.translate(canvas.width, 0), ctx.scale(-1, 1), ctx.drawImage(capImg, canvas.width - capX - capW, capY, capW, capH), ctx.restore())
              : ctx.drawImage(capImg, capX, capY, capW, capH);
            const captionSize = Math.max(12, Math.round(canvas.height * 0.02)),
              captionY = canvas.height - Math.round(canvas.height * 0.025),
              drawCaption = () => {
                showCaption &&
                  ((ctx.fillStyle = '#1a1a1a'),
                  (ctx.font = `bold ${captionSize}px -apple-system, BlinkMacSystemFont, sans-serif`),
                  (ctx.textAlign = 'center'),
                  ctx.fillText(`${mockupColor} - ${side} View`, canvas.width / 2, captionY));
              },
              logoImgEl = new Image();
            ((logoImgEl.onload = () => {
              const p = d.placement,
                logoCenterX = (p.x / 100) * canvas.width,
                logoCenterY = (p.y / 100) * canvas.height,
                stageCapW = stageImg.offsetWidth || stageEl.offsetWidth * 0.85,
                logoW = (p.w / stageCapW) * capW,
                logoH = (logoImgEl.naturalHeight / logoImgEl.naturalWidth) * logoW;
              (ctx.save(),
                ctx.translate(logoCenterX, logoCenterY),
                ctx.rotate(((p.r || 0) * Math.PI) / 180),
                ctx.drawImage(logoImgEl, -logoW / 2, -logoH / 2, logoW, logoH),
                ctx.restore(),
                drawCaption(),
                resolve(canvas.toDataURL(mimeType, quality)));
            }),
              (logoImgEl.onerror = () => {
                (drawCaption(), resolve(canvas.toDataURL(mimeType, quality)));
              }),
              (logoImgEl.src = ldThreadCaptureData));
          }),
          (capImg.onerror = () => {
            (console.error('Failed to load cap image for mockup'), resolve(ldThreadCaptureData));
          }),
          (capImg.src = capData.url));
      })
    );
  }
  const showOrderError = (html) => {
      ((orderErrorEl.innerHTML = html), orderErrorEl.classList.add('show'));
    },
    hideOrderError = () => {
      ((orderErrorEl.textContent = ''), orderErrorEl.classList.remove('show'));
    },
    actionsErrorEl = $('#ldm-actions-error'),
    showActionsError = (msg) => {
      actionsErrorEl && ((actionsErrorEl.innerHTML = msg), actionsErrorEl.classList.add('show'));
    },
    hideActionsError = () => {
      actionsErrorEl && actionsErrorEl.classList.remove('show');
    };
  let checkoutNavigationPending = !1;
  window.addEventListener('pageshow', () => {
    checkoutNavigationPending && ((checkoutNavigationPending = !1), processing.classList.remove('show'), (ctaEl.disabled = !1));
  });
  async function runCheckoutFlow() {
    try {
      await ldRunPreparation(async (ldCheckPreparation) => { await prepareTextDesigns(); ldCheckPreparation(); });
    } catch {
      showOrderError('The font could not load. Please choose another font and try again.');
      return;
    }
    (hideError(), hideOrderError());
    const locs = countDesigns();
    if (!locs) {
      (showOrderError(
        'Add a logo or text before checking out. Just want blank caps, no embroidery? <a href="/pages/b2b-order-form" style="color:inherit;text-decoration:underline;">Order blanks here</a>.',
      ),
        trackEvent('BlankCapPrompted', { where: 'order-panel' }));
      return;
    }
    if (state.qty < 25) {
      showOrderError(
        'Minimum order quantity is 25 hats. Only need a few? <a href="/pages/custom-hats-inquiry#d715-inquiry" style="color:inherit;text-decoration:underline;">Ask us about your project</a>.',
      );
      return;
    }
    const procText2 = processing.querySelector('.ldm-processing-text');
    (procText2 && (procText2.textContent = 'Saving your design'), processing.classList.add('show'), (ctaEl.disabled = !0));
    try {
      const base = getBase(state.qty),
        emb = locs * EMB_PRICE,
        per = base + emb,
        sides = getDesignSides(),
        checkoutValue = +(per * state.qty).toFixed(2),
        checkoutContentName = `${P.title} - ${state.color}`,
        pixelContents = [{ id: slug(P.title) + '-' + slug(state.color), quantity: state.qty, item_price: per.toFixed(2) }],
        pixelContentIds = pixelContents.map((c) => c.id),
        fbIcEventId = genEventId('ic_custom_cap'),
        fbCustomEventId = genEventId('ccc_custom_cap');
      _lastSavedEmail && fbAdvancedInit(_lastSavedEmail);
      const fbCheckoutContext = {
        eventId: fbIcEventId,
        customEventId: fbCustomEventId,
        eventSourceUrl: location.href,
        fbp: getFbp(),
        fbc: getFbc(),
        email: _lastSavedEmail || void 0,
        value: checkoutValue,
        currency: 'USD',
        contentName: checkoutContentName,
        contents: pixelContents,
      };
      typeof fbq == 'function' &&
        (fbq(
          'track',
          'InitiateCheckout',
          {
            content_name: checkoutContentName,
            content_category: 'Custom Caps',
            content_ids: pixelContentIds,
            contents: pixelContents,
            num_items: state.qty,
            value: checkoutValue,
            currency: 'USD',
          },
          { eventID: fbIcEventId },
        ),
        fbq(
          'trackCustom',
          'CustomCapCheckout',
          { content_name: checkoutContentName, content_category: 'Custom Caps', num_items: state.qty, value: checkoutValue, currency: 'USD' },
          { eventID: fbCustomEventId },
        ));
      let designId = null,
        designLink = '';
      try {
        const saved = await saveDesignToCloud(_lastSavedEmail, null);
        ((designId = saved.id), (designLink = saved.url));
      } catch (saveErr) {
        console.error('Pre-checkout save failed:', saveErr);
      
if (ldThreadHasOverrides()) throw new Error('Your thread-color choices could not be saved. Your design is still here; please try again.');
}
      procText2 && (procText2.textContent = 'Preparing your order');
      const attachments = [],
        orderEmailPreset = mockupPreset(sides.length, 'email'),
        orderEmailExt = extForMime(orderEmailPreset.mimeType);
      await ldRunPreparation(async (ldCheckPreparation) => { await Promise.all(
        sides.map(async (side) => {
          try {
            const cached = _lastCloudMockups && _lastCloudMockups.color === state.color ? _lastCloudMockups.bySide[side] : null,
              mockupData = cached && cached.startsWith('data:' + orderEmailPreset.mimeType) ? cached : await captureMockup(side, state.color, orderEmailPreset);
            mockupData &&
              attachments.push({
                filename: `mockup-${side.toLowerCase()}-${state.color.replace(/\s+/g, '-').toLowerCase()}.${orderEmailExt}`,
                content: mockupData.split(',')[1],
                contentType: orderEmailPreset.mimeType,
              });
          } catch (mockupErr) {
            console.error(`Failed to generate mockup for ${state.color}/${side}:`, mockupErr);
          }
        }),
      ); ldCheckPreparation(); });
      const specialRequestsValue = ((specialRequestsEl && specialRequestsEl.value) || '').trim(),
        baseProps = { 'Embroidery Locations': sides.join(', '), 'Base Price': formatMoney(base), 'Embroidery Cost': formatMoney(emb) };
      designId && (baseProps['Design #'] = designId);
      let line_items;
      if (mixOn())
        line_items = state.mix.map((r, i) => ({
          title: `${PRODUCT_NAME} - ${r.color}`,
          quantity: r.qty,
          price: per.toFixed(2),
          taxable: !1,
          properties: Object.assign(
            { Color: r.color, Sizes: rowSizesLabel(r) },
            baseProps, ldThreadProps(r.color),
            i === 0 && specialRequestsValue ? { 'Special Requests': specialRequestsValue.slice(0, 500) } : {},
          ),
        }));
      else {
        const props = Object.assign({ Color: state.color, Sizes: sizesLabel() }, baseProps, ldThreadProps(state.color));
        (specialRequestsValue && (props['Special Requests'] = specialRequestsValue.slice(0, 500)),
          (line_items = [{ title: `${PRODUCT_NAME} - ${state.color}`, quantity: state.qty, price: per.toFixed(2), taxable: !1, properties: props }]));
      }
      let customerNote = `Custom cap: ${state.qty} units, ${sides.join(', ')} embroidery${designId ? ` \u2014 Design ${designId}` : ''}`;
      (mixOn()
        ? (customerNote += `

Color mix:
${orderMixDetail()}`)
        : (customerNote += `
Sizes: ${sizesLabel()}`),
        specialRequestsValue &&
          (customerNote += `

Special requests:
${specialRequestsValue.slice(0, 500)}`));
      const orderTags = designId ? [`design-${designId}`, 'custom-cap-configurator'] : ['custom-cap-configurator'];
      (mixOn() && orderTags.push('color-mix'), specialRequestsValue && orderTags.push('has-special-requests'));
      const { resp, data } = await ldFetchCheckout({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line_items,
            customer_note: customerNote,
            checkout_attachments: designId ? void 0 : attachments,
            email: _lastSavedEmail || void 0,
            tags: orderTags,
            fb: fbCheckoutContext,
            sides_count: Math.max(1, sides.length || 1),
          }),
        });
      if (!resp.ok) throw (console.error('Draft order failed:', data), new Error(data.error || 'Order failed'));
      const emailPayload = {
        to: _lastSavedEmail,
        bcc: 'wholesale@liftdown.com',
        replyTo: 'wholesale@liftdown.com',
        subject: `Your custom cap order${designId ? ` - ${designId}` : ''}`,
        html: window.LiftDownConfiguratorEmails.order({
          product: PRODUCT_NAME,
          color: state.color,
          mix: mixOn() ? state.mix.map((row) => `${row.color}: ${row.qty}${rowSizesSuffix(row)}`) : [],
          sizes: sizesLabel(),
          quantity: state.qty,
          placements: sides.join(', '),
          reference: designId,
          unitPrice: formatMoney(per),
          subtotal: formatMoney(per * state.qty),
          instructions: specialRequestsValue.slice(0, 500),
          designURL: designLink,
          checkoutURL: data.invoice_url,
          attachmentCount: attachments.length,
        }),
        attachments,
      };
      if (_lastSavedEmail && !data.receipt_managed) {
        procText2 && (procText2.textContent = 'Sending your email');
        try {
          const emailController = new AbortController(),
            emailTimeout = setTimeout(() => emailController.abort(), 1e4),
            emailResp = await fetch(EMAIL_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(emailPayload),
              signal: emailController.signal,
            });
          (clearTimeout(emailTimeout), emailResp.ok || console.error('[email] send failed status:', emailResp.status));
        } catch (emailErr) {
          console.error('[email] send failed:', emailErr);
        }
      }
      ((checkoutNavigationPending = !0), (window.location.href = data.invoice_url));
    } catch (e) {
      ((checkoutNavigationPending = !1),
        console.error('Order error:', e),
        processing.classList.remove('show'),
        (ctaEl.disabled = !1),
        console.error('[order] failed:', e),
        showOrderError(
          'Something went wrong \u2014 please try again. Email <a href="mailto:wholesale@liftdown.com" style="color:inherit;text-decoration:underline;">wholesale@liftdown.com</a> if this persists.',
        ));
    }
  }
  const isValidEmail = (v) => /^[^\s@.]+(?:\.[^\s@.]+)*@[^\s@.]+(?:\.[^\s@.]+)+$/.test(String(v || '').trim()),
    syncSaveBtn = () => {
      const v = saveEmailInput.value.trim();
      saveSubmit.disabled = !(v === '' || isValidEmail(v));
    },
    syncOrderBtn = () => {
      ctaEl.disabled = !1;
    };
  (saveEmailInput.addEventListener('input', () => {
    (orderEmailInput.value !== saveEmailInput.value && (orderEmailInput.value = saveEmailInput.value), syncSaveBtn(), syncOrderBtn());
  }),
    orderEmailInput.addEventListener('input', () => {
      (saveEmailInput.value !== orderEmailInput.value && (saveEmailInput.value = orderEmailInput.value), syncOrderBtn(), syncSaveBtn());
    }),
    syncSaveBtn(),
    syncOrderBtn());
  function showSavePanel() {
    ((orderPanel.style.display = 'none'),
      (savePanel.style.display = 'block'),
      saveEmailInput.value || (saveEmailInput.value = orderEmailInput.value || _lastSavedEmail || ''),
      syncSaveBtn(),
      setTimeout(() => saveEmailInput && saveEmailInput.focus(), 50));
  }
  function showOrderPanel() {
    if ((hideActionsError(), !countDesigns())) {
      (showActionsError(
        'Add a logo or text before checking out. Just want blank caps, no embroidery? <a href="/pages/b2b-order-form" style="color:inherit;text-decoration:underline;">Order blanks here</a>.',
      ),
        trackEvent('BlankCapPrompted', { where: 'actions-row' }));
      return;
    }
    if (state.qty < 25) {
      showActionsError(
        'Minimum order quantity is 25 hats. Only need a few? <a href="/pages/custom-hats-inquiry#d715-inquiry" style="color:inherit;text-decoration:underline;">Ask us about your project</a>.',
      );
      return;
    }
    ((savePanel.style.display = 'none'),
      (orderPanel.style.display = 'block'),
      orderEmailInput.value || (orderEmailInput.value = saveEmailInput.value || _lastSavedEmail || ''),
      hideOrderError(),
      syncOrderBtn(),
      setTimeout(() => orderEmailInput.focus(), 50));
  }
  (saveToggleBtn &&
    (saveToggleBtn.onclick = () => {
      (showSavePanel(), savePanel.style.display === 'block' && isValidEmail(saveEmailInput.value) && saveSubmit.click());
    }),
    orderToggleBtn &&
      (orderToggleBtn.onclick = () => {
        (showOrderPanel(), orderPanel.style.display === 'block' && isValidEmail(orderEmailInput.value) && ctaEl.click());
      }),
    (ctaEl.onclick = async () => {
      const entered = orderEmailInput.value.trim();
      ((_lastSavedEmail = isValidEmail(entered) ? entered.toLowerCase() : ''), hideOrderError(), await runCheckoutFlow());
    }),
    orderEmailInput.addEventListener('keydown', (e) => {
      e.key === 'Enter' && !ctaEl.disabled && (e.preventDefault(), ctaEl.click());
    }));
  function trackEvent(eventName, data, eventId) {
    (typeof fbq == 'function' && (eventId ? fbq('trackCustom', eventName, data || {}, { eventID: eventId }) : fbq('trackCustom', eventName, data || {})),
      window.dispatchEvent(new CustomEvent('ldm:' + eventName, { detail: data || {} })));
  }
  const LS_KEY = 'ldm_autosave',
    LS_DESIGNS_KEY = 'ldm_autosave_designs';
  let _autoSaveTimer = null,
    _lastBitmapSig = null;
  function autoSave() {
const ldThreadSaveSequence = ++ldThreadAutoSaveSequence;

    (clearTimeout(_autoSaveTimer),
      (_autoSaveTimer = setTimeout(async () => {
let ldThreadPreviousHeavy, ldThreadPreviousBitmapSig = _lastBitmapSig, ldThreadHeavyWritten = false;

        try {
const threadFeature = ldThreadHasOverrides();
if (threadFeature) ldThreadPreviousHeavy = localStorage.getItem(LS_DESIGNS_KEY);
const threadSources = {};
if (threadFeature) {
  for (const side of getDesignSides()) {
    const d = state.designs[side];
    if (d.mode !== 'text' && Object.keys(window.LiftDownThreadColors.sanitizeMap(d.threadByColor, { colors: COLORS, mode: d.mode })).length) {
      threadSources[side] = await ldThreadFitRaster(await window.LiftDownThreadColors.originalSource(d));
    }
  }
}
if (ldThreadSaveSequence !== ldThreadAutoSaveSequence) return;

          const payload = {
            color: state.color,
            qty: state.qty,
            mix: state.mix ? state.mix.map((r) => ({ color: r.color, qty: r.qty, s: r.s, xl: r.xl })) : null,
            sizes: state.sizes,
            side: state.side,
            specialRequests: (specialRequestsEl && specialRequestsEl.value) || '',
            designs: {},
          };
          for (const s of ['Front', 'Back', 'Side']) {
            const d = state.designs[s];
            (d.data || d.textConfig.text.trim()) && (payload.designs[s] = ({ ...{ placement: d.placement, mode: d.mode, textConfig: d.textConfig, fileName: d.file?.name || null }, ...(threadFeature ? ldThreadLocalMetadata(d) : {}) }));
          }
          (threadFeature ? undefined : localStorage.setItem(LS_KEY, JSON.stringify(payload)));
          const sig = (threadFeature ? ldThreadFingerprint() : ['Front', 'Back', 'Side'].map((s) => (state.designs[s].data || '').length).join(','));
if (threadFeature) payload._threadSnapshot = sig;
          if (sig !== _lastBitmapSig) {
            (threadFeature ? undefined : (_lastBitmapSig = sig));
            const bitmaps = {};
if (threadFeature) (bitmaps._threadSources = threadSources, bitmaps._threadSnapshot = sig);
            for (const s of ['Front', 'Back', 'Side']) state.designs[s].data && (bitmaps[s] = state.designs[s].data);
            ((localStorage.setItem(LS_DESIGNS_KEY, JSON.stringify(bitmaps)), ldThreadHeavyWritten = threadFeature), threadFeature ? (_lastBitmapSig = sig) : undefined);
          }
        
if (threadFeature) localStorage.setItem(LS_KEY, JSON.stringify(payload));
} catch {
if (ldThreadHeavyWritten) {
  try {
    if (ldThreadPreviousHeavy == null) localStorage.removeItem(LS_DESIGNS_KEY);
    else localStorage.setItem(LS_DESIGNS_KEY, ldThreadPreviousHeavy);
  } catch (_) { /* Snapshot tokens prevent a mixed restore if rollback also fails. */ }
  _lastBitmapSig = ldThreadPreviousBitmapSig;
}
}
      }, 1e3)));
  }
  function restoreFromLocalStorage() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (!raw) return !1;
      const saved = JSON.parse(raw);
      if (
        (saved.color && COLORS.includes(saved.color) && (state.color = saved.color),
        saved.qty >= 25 && saved.qty <= 99999 && ((state.qty = saved.qty), (qtyEl.value = saved.qty)),
        Array.isArray(saved.mix) && saved.mix.length)
      ) {
        const rows = saved.mix
          .filter((r) => r && COLORS.includes(r.color))
          .map((r) => ({ color: r.color, qty: Math.min(99999, Math.max(25, r.qty | 0)), s: Math.max(0, r.s | 0), xl: Math.max(0, r.xl | 0) }));
        state.mix = rows.length ? rows : null;
      }
      ((mixPreviewColor = null),
        mixOn() && !state.mix.some((row) => row.color === state.color) && (state.color = state.mix[0].color),
        saved.sizes && ((state.sizes = { s: Math.max(0, saved.sizes.s | 0), xl: Math.max(0, saved.sizes.xl | 0) }), (state.sizes.s || state.sizes.xl) && openGlobalSizes()),
        typeof saved.specialRequests == 'string' &&
          specialRequestsEl &&
          ((specialRequestsEl.value = saved.specialRequests), saved.specialRequests.trim() && specialRequestsWrap && setSpecialRequestsExpanded(!0)));
      let bitmaps = {};
      try {
        bitmaps = JSON.parse(localStorage.getItem(LS_DESIGNS_KEY) || '{}');
      } catch {}
if ((saved._threadSnapshot || bitmaps._threadSnapshot) && saved._threadSnapshot !== bitmaps._threadSnapshot) return false;
      if (saved.designs)
        for (const s of ['Front', 'Back', 'Side']) {
          const sd = saved.designs[s];
          if (!sd) continue;
          const d = state.designs[s];
ldThreadRestoreMetadata(d, sd, bitmaps._threadSources && bitmaps._threadSources[s], sd.data || bitmaps[s]);
          ((sd.data || bitmaps[s]) && (d.data = sd.data || bitmaps[s]),
            sd.placement && (d.placement = { ...d.placement, ...sd.placement }),
            sd.textConfig && (d.textConfig = { ...d.textConfig, ...sd.textConfig }),
            sd.mode && (d.mode = sd.mode),
            sd.fileName ? (d.file = { name: sd.fileName, type: '' }) : sd.data && (d.file = { name: 'Restored design', type: '' }));
        }
      return !0;
    } catch {
      return !1;
    }
  }
  const _origUpdatePricing = updatePricing;
  ((updatePricing = function () {
    (_origUpdatePricing(), autoSave(), updateProgress());
  }),
    specialRequestsEl && specialRequestsEl.addEventListener('input', autoSave));
  function updateProgress() {
    const steps = $$('.ldm-progress-step'),
      lines = [$$('#ldm-prog-line-1')[0], $$('#ldm-prog-line-2')[0]],
      hasColor = !!state.color,
      hasDesign = ['Front', 'Back', 'Side'].some((s) => !!state.designs[s].data),
      hasQty = state.qty >= 25;
    (steps.forEach((s, i) => {
      (s.classList.remove('active', 'done'),
        i === 0 && hasColor && s.classList.add('done'),
        i === 1 && hasDesign ? s.classList.add('done') : i === 1 && hasColor && s.classList.add('active'),
        i === 2 && hasDesign && hasQty ? s.classList.add('done') : i === 2 && hasDesign && s.classList.add('active'));
      const dot = s.querySelector('.ldm-progress-dot');
      s.classList.contains('done')
        ? (dot.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>')
        : (dot.textContent = i + 1);
    }),
      lines[0] && lines[0].classList.toggle('filled', hasColor && hasDesign),
      lines[1] && lines[1].classList.toggle('filled', hasDesign && hasQty));
    const saveDesignEl = $('#ldm-save-design');
    saveDesignEl && saveDesignEl.classList.toggle('has-design', hasDesign);
  }
  let _exitShown = !1;
  function applyUrlParams() {
    const params = new URLSearchParams(window.location.search),
      c = params.get('color');
    if (c) {
      const match = COLORS.find((x) => x.toLowerCase() === c.toLowerCase());
      match && setPreviewColor(match);
    }
    const q = parseInt(params.get('qty'), 10);
    !mixOn() && Number.isFinite(q) && q >= 25 && q <= 99999 && ((state.qty = q), qtyEl && (qtyEl.value = q));
  }
  const hasUrlDesign = new URLSearchParams(window.location.search).has('design');
  (hasUrlDesign || (restoreFromLocalStorage(), applyUrlParams()),
    renderSwatches(),
    renderTabs(),
    syncViewBtns(),
    updateStage(),
    updateUploadUI(),
    renderMix(),
    updatePricing(),
    updateProgress(),
    hasUrlDesign && restoreFromURL());
  const gridEl = $('#ldm-grid');
  gridEl && (gridEl.style.opacity = '1');
  const cfgEl = $('.ldm-config');
  cfgEl && (cfgEl.style.opacity = '1');
  try {
    if (typeof fbq == 'function') {
      const startingValue = (TIERS[0].price + EMB_PRICE) * 25;
      fbq(
        'track',
        'ViewContent',
        { content_name: P.title, content_category: 'Custom Caps', content_ids: [String(P.id || P.handle || '')], content_type: 'product', value: startingValue, currency: 'USD' },
        { eventID: genEventId('vc') },
      );
    }
  } catch {}
});
//# sourceMappingURL=/cdn/shop/t/194/assets/ld-cc-app.js.map?v=102300862329178701751793290526
